import { STORAGE_APPOINTMENT_HEAD_ORDER, STORAGE_INN_NAMESPACE, STORAGE_SIGNED_REQUEST } from "@rmp/core/constants/storage";
import { CounterpartyTypeEnum } from "@rmp/core/types/CounterpartyTypeEnum";
import { ApiDtoTrustUiStatus } from "@rmp/api-gateway";
import { ApiPropertiesBoatType } from "@rmp/core/types/boat/propertyBoat";
import { ApiServiceApplicationDocumentKind } from "@rmp/core/types/services/serviceDocumentKind";
import { ApiServicesPaymentMethod } from "@rmp/core/types/agreement/servicesPaymentMethod";
import { ApiServicesAgreementWorkflowTransitionKind } from "@rmp/core/types/agreement/agreementTransitionKind";
import { ArchiveStatusType } from "@rmp/core/types/ArchiveStatusType";

import {
	ApiCounterpartyBoatApplicationStatus,
	ApiServicesAgreementWorkflowStateKind,
	ApiEnterprisePropertyType,
	ApiCounterpartyDeletionBlockerType,
	ApiCounterpartyDocumentsDocumentType,
	ApiDivisionDeletionBlockerType,
	ApiDivisionsContactType,
	ApiGetTrustActioner_ActionerKind,
	ApiNotificationsRecipientType,
	ApiRoleDeletionBlockerType,
	ApiServiceApplicationWorkflowTransitionKind,
	ApiServiceRequestsMasterApplicationStatus,
	ApiServiceType,
	ApiServiceWorkflowStateKind,
	ApiTariffsUnit
} from "@rmp/api-gateway";
import { ApplicationFilterStatusType } from "@rmp/core/types/ApplicationFilterStatusType";
import { BoatApplicationDocumentType } from "@rmp/core/types/boatApplicationDocumentType";
import { DocumentType } from "@rmp/core/types/documentType";

import { AgreementDocumentKindEnum } from "@rmp/core/types/agreement/agreementDocumentKindEnum";

import { MetricsPeriodType } from "@rmp/core/types/metrics/metricsPeriodType";

import { TariffRateStatusTypeEnum } from "@rmp/core/types/TariffRateStatusTypeEnum";

import { timezoneNames } from "@rmp/core/utils/dates";
import errors from "@rmp/core/plugins/i18n/locales/ru/errors";

export default {
	counterpartyEdo: {
		tab: "ЭДО",
		title: "Реквизиты ЭДО",
		edit: "Изменить реквизиты ЭДО",
		operator: "Оператор ЭДО",
		diadoc: "Контур.Диадок",
		integration: "Интеграция с ЭДО",
		configured: "Настроена",
		notConfigured: "Не настроена",
		fnsParticipantId: "Идентификатор ЭДО",
		boxId: "Идентификатор ящика",
		lastVerifiedAt: "Последняя успешная проверка",
		selectPlaceholder: "Выберите идентификатор ЭДО",
		candidateLabel: "{identifier} — {name}, КПП {kpp}",
		candidateLabelWithoutKpp: "{identifier} — {name}",
		noCandidates: "Не удалось найти действующее подключение организации к ФГУП «Росморпорт» в Контур.Диадок.",
		noCandidatesHint: "Если организация ещё не использует ЭДО, пройдите регистрацию. Если уже использует — проверьте подключение к ФГУП «Росморпорт», включая настройку роуминга при работе через другого оператора ЭДО.",
		multipleCandidates: "Найдено несколько идентификаторов ЭДО. Выберите идентификатор для обмена документами с ФГУП «Росморпорт».",
		boxIdNotFound: "Действующее подключение к ФГУП «Росморпорт» в Контур.Диадок не найдено.",
		openDiadoc: "Открыть Контур.Диадок",
		candidatesError: "Не удалось загрузить ящики из Контур.Диадок. Повторите попытку позже.",
		retry: "Повторить загрузку"
	},
	errors,
	divisionScope: {
		label: "Подразделения, в списках которых будет отображаться объект",
		fieldLabel: "Подразделения",
		hint: "Каждая отметка соответствует одному подразделению. Дочерние подразделения автоматически не включаются.",
		unknown: "Неизвестное подразделение: {id}",
		rootRequired: "Выберите основное подразделение",
		rootNotFound: "Выбранное основное подразделение отсутствует в актуальной структуре"
	},
	serviceProviderDivision: {
		label: "Оказывающее подразделение"
	},
	timezones: {
		[timezoneNames.KALININGRAD]: "Калининград",
		[timezoneNames.MOSCOW]: "Москва",
		[timezoneNames.YEKATERINBURG]: "Екатеринбург",
		[timezoneNames.OMSK]: "Омск",
		[timezoneNames.NOVOSIBIRSK]: "Новосибирск",
		[timezoneNames.IRKUTSK]: "Иркутск",
		[timezoneNames.YAKUTSK]: "Якутск",
		[timezoneNames.VLADIVOSTOK]: "Владивосток",
		[timezoneNames.MAGADAN]: "Магадан",
		[timezoneNames.KAMCHATKA]: "Камчатка"
	},
	fields: {
		serviceDefinition: {
			label: "Шаблон услуг",
			placeholder: "Выберите шаблон услуг"
		},
		serviceDefinitions: {
			label: "Шаблоны услуг",
			placeholder: "Выберите шаблоны услуг"
		},
		ports: {
			label: "Порты",
			placeholder: "Выберите порты"
		},
		validFrom: {
			label: "Дата начала действия",
			placeholder: "Введите дату начала действия"
		},
		validTo: {
			label: "Дата окончания действия",
			placeholder: "Введите дату окончания действия"
		},
		latitude: {
			label: "Широта, °",
			placeholder: "Введите значение широты"
		},
		longitude: {
			label: "Долгота, °",
			placeholder: "Введите значение долготы"
		},
		dateOfBirth: {
			label: "Дата рождения",
			placeholder: "Введите дату рождения"
		},
		hasAdminAccess: {
			label: "Есть доступ в личный кабинет администратора"
		},
		limitAmount: {
			label: "Максимальная стоимость, руб.",
			placeholder: "Введите максимальную стоимость"
		},
		departments: {
			placeholder: "Выберите управление"
		},
		communicationMethod: {
			label: "Способ связи",
			placeholder: "Выберите способ"
		},
		dayOfWeek: {
			label: "День недели",
			placeholder: "Выберите день недели"
		},
		startTime: {
			label: "Время начала",
			placeholder: "ЧЧ:ММ"
		},
		endTime: {
			label: "Время окончания",
			placeholder: "ЧЧ:ММ"
		},
		workSchedule: {
			noScheduleForDay: "Нет расписания на этот день"
		},
		subject: {
			label: "Тема письма",
			placeholder: "Введите тему письма"
		},
		note: {
			label: "Примечание",
			placeholder: "Введите примечание"
		},
		endDate: {
			label: "Дата окончания",
			placeholder: "Выберите дату"
		},
		isPublic: {
			label: "Публичный"
		},
		priority: {
			label: "Приоритет",
			placeholder: "Введите значение"
		},
		vhf: {
			label: "УКВ",
			placeholder: "Введите канал УКВ",
			title: "Каналы УКВ",
			empty: "Добавьте каналы УКВ"
		},
		vhfCallsign: {
			label: "Позывной",
			placeholder: "Введите позывной"
		},
		other: {
			placeholder: "Введите данные для связи с контактом",
			label: "Другое"
		},
		ext: {
			label: "Добавочный номер",
			placeholder: "###"
		},
		contactType: {
			label: "Тип"
		},
		contactName: {
			label: "Наименование",
			placeholder: "Дежурный лоцман"
		},
		registrationDate: {
			label: "Дата регистрации",
			placeholder: "Выберите дату"
		},
		relatedTo: {
			label: "Относится к",
			placeholder: "Выберите подразделение"
		},
		pier: {
			label: "Причал",
			placeholder: "Выберите причал(ы)"
		},
		floatingCrane: {
			label: "Плавкран",
			placeholder: "Выберите плавкран(ы)"
		},
		crewboat: {
			label: "Разъездное судно",
			placeholder: "Выберите разъездные суда"
		},
		boat: {
			label: "Cудно",
			placeholder: "Выберите судно"
		},
		counterpartyBoat: {
			label: "Судно контрагента",
			placeholder: "Выберите судно"
		},
		tariff: {
			label: "Тариф",
			placeholder: "Выберите тариф(ы)"
		},
		tugBoat: {
			label: "Буксир",
			placeholder: "Выберите буксир(ы)"
		},
		icebreaker: {
			label: "Ледокол",
			placeholder: "Выберите ледокол"
		},
		port: {
			label: "Порт",
			placeholder: "Выберите порт"
		},
		agreement: {
			label: "Договор",
			placeholder: "Выберите договор"
		},
		publicOffer: {
			label: "Публичная оферта",
			placeholder: "Выберите публичную оферту"
		},
		guaranteeLetterFile: {
			label: "Файл гарантийного письма"
		},
		unit: {
			label: "Единица измерения",
			placeholder: "Выберите единицу измерения"
		},
		vat: {
			label: "НДС",
			placeholder: "Выберите НДС"
		},
		serviceType: {
			label: "Тип услуг",
			placeholder: "Выберите тип услуг"
		},
		nomenclatureCode: {
			label: "Код номенклатуры",
			placeholder: "Введите код номенклатуры"
		},
		activityType: {
			label: "Вид деятельности",
			placeholder: "Введите вид деятельности"
		},
		confirmationDocumentName: {
			label: "Наименование документа",
			placeholder: "Введите наименование документа"
		},
		confirmationDocumentUploadRequired: {
			label: "Обязателен к загрузке"
		},
		confirmationDocumentMultipleDocumentsAllowed: {
			label: "Множественная загрузка"
		},
		serviceTypes: {
			label: "Доступные услуги"
		},
		additionalService: {
			label: "Дополнительные услуги",
			placeholder: "Выберите услуги"
		},
		tariffType: {
			label: "Тип тарифа",
			placeholder: "Выберите тип тарифа"
		},
		algorithm: {
			label: "Алгоритм",
			placeholder: "Выберите алгоритм"
		},
		unregisteredBoat: {
			label2: "Поиск судна",
			placeholder: "Для поиска судна можете использовать наименование судна, позывной"
		},
		notFoundBoat: {
			label: "Судно не найдено, проверьте введенные сведения или создайте новое судно"
		},
		calculationObjectCode: {
			label: "Калькуляционный объект (КО)",
			placeholder: "Введите значение"
		},
		harborDuesIdentifier: {
			label: "Идентификатор",
			placeholder: "Введите значение"
		},
		paymentMethod: {
			label: "Выберите способ оплаты по договору "
		},
		agreementStartDate: {
			label: "Дата начала",
			placeholder: "ДД.ММ.ГГГГ"
		},
		agreementEndDate: {
			label: "Дата окончания",
			placeholder: "ДД.ММ.ГГГГ"
		},
		agreementDate: {
			label: "Дата договора",
			placeholder: "ДД.ММ.ГГГГ"
		},
		propertyType: {
			placeholder: "Тип объекта"
		},
		dateFrom: {
			placeholder: "с"
		},
		dateUntil: {
			placeholder: "по"
		},
		enterprise: {
			placeholder: "Все управления"
		},
		property: {
			label: "Объект имущества",
			placeholder: "Все объекты имущества"
		},
		tariffApprovalOrder: {
			label: "Приказ",
			placeholder: "Выберите приказ из списка",
			optionsTitle: "Приказ №{orderNumber} от {approvalDate}"
		},
		tariffApprovalOrderNumber: {
			label: "Номер приказа",
			placeholder: "Введите номер приказа"
		},
		tariffApprovalOrderApprovalDate: {
			label: "Дата утверждения",
			placeholder: "Введите дату"
		},
		period: {
			placeholder: "Период"
		},
		date: {
			placeholder: "Введите дату",
			label: "Дата"
		},
		validUntilDate: {
			placeholder: "Введите дату",
			label: "Действительна до"
		},
		validFromDate: {
			placeholder: "Введите дату",
			label: "Действует с"
		},
		phone: {
			placeholder: "Введите номер телефона",
			label: "Номер телефона"
		},
		email: {
			placeholder: "Введите адрес электронной почты",
			label: "Адрес электронной почты"
		},
		simpleEmail: {
			placeholder: "Введите адрес электронной почты",
			label: "Адрес электронной почты"
		},
		password: {
			placeholder: "Введите пароль",
			label: "Пароль"
		},
		newPassword: {
			placeholder: "Введите пароль",
			label: "Ваш новый пароль"
		},
		confirmedPassword: {
			placeholder: "Повторите пароль",
			label: "Введите пароль"
		},
		inn: {
			placeholder: "Введите ИНН",
			label: "ИНН"
		},
		ogrn: {
			placeholder: "Введите ОГРН",
			label: "ОГРН"
		},
		ogrnip: {
			placeholder: "Введите ОГРНИП",
			label: "ОГРНИП"
		},
		kpp: {
			placeholder: "Введите КПП",
			label: "КПП"
		},
		timeZone: {
			label: "Часовой пояс",
			placeholder: "Выберите часовой пояс"
		},
		opf: {
			placeholder: "Введите организационно-правовую форму",
			label: "Организационно-правовая форма"
		},
		snils: {
			placeholderInput: "Введите СНИЛС",
			label: "СНИЛС"
		},
		trust: {
			placeholder: "Выберите файл",
			label: "Доверенность"
		},
		signature: {
			placeholder: "Выберите файл",
			label: "Электронная подпись"
		},
		position: {
			placeholder: "Введите должность",
			label: "Должность"
		},
		username: {
			label: "Логин"
		},
		firstName: {
			placeholder: "Введите имя",
			label: "Имя"
		},
		lastName: {
			placeholder: "Введите фамилию",
			label: "Фамилия"
		},
		middleName: {
			placeholder: "Введите отчество",
			label: "Отчество"
		},
		personFullName: {
			placeholder: "Введите ФИО",
			label: "ФИО"
		},
		fullName: {
			placeholder: "Введите полное наименование",
			label: "Полное наименование"
		},
		name: {
			placeholder: "Введите наименование",
			label: "Наименование"
		},
		tariffName: {
			placeholder: "Введите наименование операции, например, Швартовка",
			label: "Наименование операции"
		},
		shortName: {
			placeholder: "Введите краткое наименование",
			label: "Краткое наименование"
		},
		registerDate: {
			placeholder: "Введите дату регистрации",
			label: "Дата регистрации"
		},
		counterpartyRegisterDate: {
			placeholder: "Введите дату регистрации организации",
			label: "Дата регистрации организации"
		},
		legalPersonRegisterDate: {
			placeholder: "Введите дату регистрации ИП",
			label: "Дата регистрации"
		},
		registerCountry: {
			placeholder: "Выберите страну регистрации",
			label: "Страна регистрации"
		},
		legalAddress: {
			placeholder: "Введите юридический адрес",
			label: "Юридический адрес"
		},
		comment: {
			placeholder: "Введите комментарий",
			label: "Комментарий"
		},
		isRequired: {
			label: "Обязательные услуги"
		},
		description: {
			placeholderInput: "Введите описание",
			placeholderAdd: "Добавьте описание",
			label: "Описание"
		},
		code: {
			placeholder: "Введите код",
			label: "Код"
		},
		reason: {
			placeholder: "Укажите причину",
			label: "Причина"
		},
		paymentDescription: {
			placeholder: "Напишите описание",
			label: "Назначение платежа"
		},
		paymentActiveDate: {
			placeholder: "Введите дату",
			label: "Дата, с которой задолженность становится срочной"
		},
		switch: {
			frp: {
				label: "РФРП"
			},
			leasingCompany: {
				label: "Лизинговая компания"
			},
			collateralExpertOrganisation: {
				label: "Экспертная организация по залогам"
			},
			vkmExpertCompany: {
				label: "Экспертная организация по ВКМ"
			},
			frpAssigneeCompany: {
				label: "Цессионарий"
			},
			enableFnsUpdate: {
				label: "Обновлять из Контур.Фокус по расписанию"
			},
			canSignDocumentsOnBehalfOfEnterprise: {
				label: "Может осуществлять подписание документов от имени предприятия"
			},
			receiveBrowserNotifications: {
				label: "Получать уведомления"
			}
		},
		phoneNumber: {
			label: "Контактный номер телефона",
			placeholder: "Введите номер телефона"
		},
		emailAddress: {
			label: "Контактный адрес электронной почты",
			placeholder: "Введите адрес электронной почты"
		},
		headFullName: {
			placeholder: "Введите ФИО руководителя",
			label: "ФИО"
		},
		headPosition: {
			placeholder: "Введите должность руководителя",
			label: "Должность"
		},
		headInn: {
			placeholder: "Введите ИНН руководителя",
			label: "ИНН"
		},
		headSnils: {
			placeholderInput: "Введите СНИЛС руководителя",
			label: "СНИЛС"
		},
		employeeSnils: {
			placeholderInput: "Введите СНИЛС сотрудника",
			label: "СНИЛС"
		},
		titleDocument: {
			placeholder: "Выбрать",
			label: "Документ-основание"
		},
		version: {
			placeholder: "Выбрать",
			label: "Основание"
		},
		changeReason: {
			placeholder: "Выбрать",
			label: "Причина изменения графика"
		},
		number: {
			placeholder: "Введите номер",
			label: "Номер"
		},
		amount: {
			placeholder: "Введите сумму",
			labelRUB: "Сумма, ₽"
		},
		quarter: {
			placeholder: "Выберите квартал",
			label: "Квартал"
		},
		accrualDate: {
			placeholder: "Выбрать дату",
			label: "Дата начисления"
		},
		paymentDate: {
			placeholder: "Выбрать дату",
			label: "Дата оплаты"
		},
		plannedPaymentDate: {
			placeholder: "Выбрать дату",
			label: "Дата платежа"
		},
		accountedDate: {
			placeholder: "Выбрать дату",
			label: "Дата передачи в бухгалтерию"
		},
		accrualType: {
			placeholder: "Выбрать тип",
			label: "Тип начисления"
		},
		projectNumber: {
			placeholder: "Номер проекта"
		},
		agreementNumber: {
			placeholder: "Договор займа"
		},
		originalAgreementNumber: {
			label: "Номер договора",
			placeholder: "Введите номер договора"
		},
		agreementStatus: {
			placeholder: "Статус договора"
		},
		allSelected: {
			label: "Все отмеченные"
		},
		penaltyType: {
			placeholder: "Выбрать категорию",
			label: "Категории начисления штрафов/пеней"
		},
		accruedAmount: {
			placeholder: "Введите проценты",
			label: "Сумма процентов"
		},
		additionalInterest: {
			placeholder: "Введите проценты",
			label: "Дополнительная процентная ставка"
		},
		paymentExpense: {
			placeholder: "Выберите статью ДДС",
			label: "Статья ДДС"
		},
		borrower: {
			placeholder: "Выберите заёмщика",
			label: "Заёмщик"
		},
		treasuryBorrower: {
			placeholder: "Наименование заемщика / Номер проекта / Договор",
			label: "Заёмщик"
		},
		paymentsType: {
			placeholder: "Выбрать",
			label: "Тип записи"
		},
		dropzone: {
			title: {
				uploadFile: "Перенесите файл или нажмите для загрузки"
			},
			description: {
				maxFileWeight: "Максимальный вес файла {maxSize}Мб",
				minFileWeight: "Минимальный вес файла {minSize}Мб",
				formats: "Загрузите {formats} файлы.",
				invalidFormat: "Неверный формат файла. Допустимый формат: {formats}"
			}
		},
		status: {
			placeholder: "Выберите статус",
			label: "Статус"
		},
		organization: {
			placeholder: "Выберите организацию",
			label: "Организация"
		},
		roleInProject: {
			placeholder: "Выберите роль",
			label: "Роль в проекте"
		},
		obligedCompany: {
			placeholder: "Выберите организацию",
			label: "По обязательствам какого юр.лица"
		},
		requirement: {
			placeholder: "Выберите требование",
			label: "Требование"
		},
		event: {
			placeholder: "Выберите мероприятие",
			label: "Мероприятие"
		},
		judicialDecision: {
			placeholder: "Выберите решение суда",
			label: "Решение суда"
		},
		controlDate: {
			label: "Контрольная дата"
		},
		factualDate: {
			label: "Фактическая дата"
		},
		factualPenaltySum: {
			placeholder: "Введите сумму",
			label: "Фактическая сумма взыскания, руб."
		},
		organizationName: {
			placeholder: "Введите наименование",
			label: "Наименование организации"
		},
		responsibleUser: {
			placeholder: "Выберите сотрудника",
			label: "Ответственный"
		},
		startDate: {
			label: "Дата начала",
			placeholder: "Выберите дату"
		},
		unitPrice: {
			label: "Цена за единицу измерения",
			placeholder: "Введите цену за единицу измерения"
		},
		headCertificateInn: {
			label: "Свидетельство ИНН руководителя"
		},
		appointmentHeadOrder: {
			label: "Приказ о назначении руководителем"
		},
		documentSearch: {
			placeholder: "Поиск документа"
		},
		financeSchemesSearch: {
			placeholder: "Все программы"
		},
		departmentSearch: {
			placeholder: "Подразделение ФРП"
		},
		documentSectionSearch: {
			placeholder: "Раздел документа"
		},
		activeOnly: {
			label: "Активные элементы"
		},
		financingScheme: {
			label: "Программа",
			placeholder: "Выбрать"
		},
		supervisor: {
			label: "Руководитель (лицо, акцептующее публикацию документа)",
			placeholder: "Выбрать"
		},
		documentSection: {
			label: "Раздел",
			placeholder: "Выбрать"
		},
		documentTitle: {
			label: "Наименование документа",
			placeholder: "Введите наименование документа"
		},
		documentTemplateFile: {
			label: "Файл шаблона"
		},
		documentEditableFile: {
			label: "В редактируемом формате"
		},
		documentPdfFile: {
			label: "В формате pdf"
		},
		initiator: {
			label: "Инициатор",
			placeholder: "Инициатор"
		},
		acceptedOnly: {
			label: "Согласованные заявки"
		},
		createdDate: {
			label: "Дата создания"
		},
		changeRequestDescription: {
			placeholder: "Введите описание",
			label: "Суть изменения"
		},
		changeRequestType: {
			placeholder: "Выбрать",
			label: "Тип вносимого изменения"
		},
		changeWarrant: {
			placeholder: "Введите основание",
			label: "Основание для внесения изменений"
		},
		login: {
			label: "Адрес электронной почты / ИНН организации",
			placeholder: "Введите ИНН или адрес электронной почты"
		},
		confirmationCode: {
			label: "Код подтверждения"
		},
		documentType: {
			label: "Вид документа",
			placeholder: "Выберите вид документа"
		},
		bankAccountNumber: {
			label: {
				short: "Номер счета",
				full: "Номер счета в банке"
			},
			placeholder: "Введите номер счета"
		},
		bankIdentificationCode: {
			label: "БИК",
			placeholder: "Введите БИК"
		},
		bankName: {
			label: "Наименование банка",
			placeholder: "Введите наименование банка"
		},
		correspondentAccount: {
			label: "Корреспондентский счет",
			placeholder: "Введите корреспондентский счет"
		},
		boatName: {
			label: "Наименование судна",
			placeholder: "Введите наименование судна"
		},
		shipownerName: {
			label: "Имя судовладельца",
			placeholder: "Введите имя судовладельца"
		},
		countryCode: {
			label: "Код страны",
			placeholder: "Введите код страны"
		},
		countryNameEn: {
			label: "Наименование страны (латиницей)",
			placeholder: "Введите наименование страны (латиницей)"
		},
		countryNameRu: {
			label: "Наименование страны",
			placeholder: "Введите наименование страны"
		},
		boatTranslitName: {
			label: "Наименование судна (транслит)",
			placeholder: "Введите наименование судна (транслит)"
		},
		boatIMO: {
			label: "Номер IMO",
			placeholder: "Введите номер IMO"
		},
		IMO: {
			label: "Номер IMO",
			placeholder: "Введите номер IMO"
		},
		boatOwnershipType: {
			label: "Вид владения судном",
			placeholder: "Выберите вид владения судном"
		},
		precipitationMaxValue: {
			label: "Максимальная осадка (м.)",
			placeholder: "Введите максимальную осадку"
		},
		calculatedGRT: {
			label: "Расчетное значение GRT (т.)",
			placeholder: "Введите расчетное значение GRT"
		},
		boatFlag: {
			label: "Флаг",
			placeholder: "Выберите флаг"
		},
		GRT: {
			label: "GRT (т.)",
			placeholder: "Введите GRT"
		},
		boatLength: {
			label: "Длина (м.)",
			placeholder: "Введите длину"
		},
		boatHeight: {
			label: "Высота борта (м.)",
			placeholder: "Введите высоту борта"
		},
		portOfRegistry: {
			label: "Порт регистрации",
			placeholder: "Введите порт регистрации"
		},
		yearOfBuilding: {
			label: "Год постройки",
			placeholder: "Введите год постройки"
		},
		callSign: {
			label: "Позывной",
			placeholder: "Введите позывной"
		},
		MMSI: {
			label: "Номер MMSI",
			placeholder: "Введите номер MMSI"
		},
		boatType: {
			label: "Тип судна",
			placeholder: "Выберите тип судна"
		},
		exclusionGRT: {
			label: "Исключение из GRT рег (т.)",
			placeholder: "Введите исключение из GRT"
		},
		boatBowThruster: {
			label: "Имеет подруливающие устройство",
			placeholder: "Выберите, имеет ли судно подруливающие устройство"
		},
		boatRegisterClass: {
			label: "Класс регистра",
			placeholder: "Выберите класс регистра судна"
		},
		boatDeadWeight: {
			label: "Дедвейт (т.)",
			placeholder: "Введите дедвейт"
		},
		boatWidth: {
			label: "Ширина (м.)",
			placeholder: "Введите ширину"
		},
		boatPower: {
			label: "Мощность ГД (кВт.)",
			placeholder: "Введите мощность"
		},
		numberOfRegistry: {
			label: "Регистровый номер",
			placeholder: "Введите регистровый номер"
		},
		boatStatus: {
			label: "Текущий статус",
			placeholder: "Введите текущий статус"
		},
		pierName: {
			label: "Наименование",
			placeholder: "Введите наименование"
		},
		pierLength: {
			label: "Длина причальной стенки, предназначенная для стоянки судов (м.)",
			placeholder: "Введите длину"
		},
		pierDepth: {
			label: "Глубина у причальной стенки (м.)",
			placeholder: "Введите глубину"
		},
		pierStatus: {
			label: "Текущий статус",
			placeholder: "Введите текущий статус"
		},
		shipowner: {
			label: "Судовладелец",
			placeholder: "Введите судовладельца"
		},
		ownershipCertificate: {
			label: "Свидетельство о праве плавания под флагом"
		},
		internationalMeasuringCertificate: {
			label: "Международное мерительное свидетельство"
		},
		classificationCertificate: {
			label: "Классификационное свидетельство"
		},
		internationalOilPollutionPreventionCertificate: {
			label: "Международное свидетельство о предотвращении загрязнения нефтью"
		},
		customDocument: {
			label: "Иной документ"
		},
		expirationDate: {
			label: "Истечение срока действия",
			placeholder: "Введите дату"
		},
		giveBoatDate: {
			label: "Дата подачи",
			placeholder: "ДД.ММ.ГГГГ"
		},
		giveBoatTime: {
			label: "Время подачи",
			placeholder: "ЧЧ:ММ"
		},
		startLocation: {
			label: "Место начала",
			placeholder: "Заполните сведения"
		},
		endLocation: {
			label: "Место окончания",
			placeholder: "Заполните сведения"
		},
		chatComment: {
			placeholder: "Ваш комментарий"
		},
		feedback: {
			label: "Отзыв",
			placeholder: "Добавьте отзыв"
		},
		declineReason: {
			label: "Причина отклонения",
			placeholder: "Напишите причину отклонения"
		},
		cancelReason: {
			label: "Причина отмены",
			placeholder: "Укажите причину отмены"
		},
		actualAddress: {
			label: "Фактический адрес",
			placeholder: "Введите фактический адрес"
		},
		opfName: {
			label: "Наименование ОПФ"
		},
		branch: {
			label: "Филиал",
			placeholder: "Выберите филиал"
		},
		department: {
			label: "Управление",
			placeholder: "Выберите управление"
		},
		division: {
			label: "Подразделение",
			placeholder: "Выберите подразделение"
		},
		deposit: {
			placeholder: "Введите сумму пополнения"
		},
		englishName: {
			label: "Английское наименование",
			placeholder: "Введите английское наименование"
		},
		location: {
			label: "Координаты",
			placeholder: "Введите координаты"
		},
		selectWorkHours: {
			label: "Выберите время работы"
		},
		counterparty: {
			label: "Контрагент",
			placeholder: "Выберите контрагента"
		},
		agreementDefinition: {
			label: "Вид договора",
			placeholder: "Выберите вид договора"
		},
		agreementLimitAmount: {
			label: "Лимит совокупной стоимости",
			tooltip: "Максимальная общая стоимость услуг по договору",
			placeholder: "Введите лимит совокупной стоимости услуг"
		},
		bankAccount: {
			label: "Банковский счёт",
			placeholder: "Выберите банковский счёт"
		}
	},
	alerts: {
		noData: "Нет данных",
		success: {
			signed: "Подписано ЭП"
		},
		errors: {
			loadExternalDataError: "Произошла ошибка при загрузке сведений. Пожалуйста, попробуйте еще раз",
			onSaveExternalError: "Не удалось сохранить сведения. Пожалуйста, проверьте введенные сведения и попробуйте снова",
			onCalibrationExternalError: "Ошибка инициализации процесса калибровки. Рекомендуем перезапустить операцию",
			onRequestError: "Возникла ошибка при отправке запроса",
			settings: {
				errorUpdate: "Не удалось обновить сведения пользователя. Пожалуйста, убедитесь в корректности информации и повторите попытку"
			},
			onDeleteBranchAlerts: {
				[ApiDivisionDeletionBlockerType.Employee]: "Филиал не может быть удалён в связи с привязкой к сотрудникам.",
				[ApiDivisionDeletionBlockerType.Service]: "Филиал не может быть удалён в связи с привязкой к услугам.",
				[ApiDivisionDeletionBlockerType.ChildDivision]: "Филиал не может быть удалён в связи с привязкой к управлениям или портам.",
				[ApiDivisionDeletionBlockerType.Agreement]: "Филиал не может быть удалён в связи с привязкой к действующим договорам."
			},
			onDeleteCounterpartyAlerts: {
				[ApiCounterpartyDeletionBlockerType.Employees]: "Контрагент не может быть удален в связи с привязкой к сотрудникам.",
				[ApiCounterpartyDeletionBlockerType.Accounts]: "Контрагент не может быть удален в связи с привязкой к аккаунтам."
			},
			onDeleteDepartmentAlerts: {
				[ApiDivisionDeletionBlockerType.Employee]: "Управление не может быть удалено в связи с привязкой к сотрудникам.",
				[ApiDivisionDeletionBlockerType.Service]: "Управление не может быть удалено в связи с привязкой к услугам.",
				[ApiDivisionDeletionBlockerType.ChildDivision]: "Управление не может быть удалено в связи с привязкой к портам.",
				[ApiDivisionDeletionBlockerType.Agreement]: "Управление не может быть удалено в связи с привязкой к действующим договорам."
			},
			onDeleteRoleAlerts: {
				[ApiRoleDeletionBlockerType.Employee]: "Роль не может быть удалена в связи с привязкой к сотрудникам.",
				[ApiRoleDeletionBlockerType.Profile]: "Роль не может быть удалена в связи с привязкой к профилям."
			},
			onDeletePortAlerts: {
				Employee: "Порт не может быть удалён в связи с привязкой к сотрудникам.",
				Service: "Порт не может быть удалён в связи с привязкой к услугам.",
				Agreement: "Порт не может быть удалён в связи с привязкой к действующим договорам."
			},
			organisationAlreadyExists: "Организация с указанным именем уже зарегистрирована в системе",
			legalEntityAlreadyExists: "Указанный ИНН уже принадлежит другому зарегистрированному юридическому лицу",
			legalPersonAlreadyExists: "Введенный ИНН уже принадлежит другому зарегистрированному ИП",
			physicalPersonAlreadyExists: "Введенный ИНН уже принадлежит другому зарегистрированному физическому лицу",
			requiredInnForLegalEntity: "Для автоматического заполнения сведений, пожалуйста, введите ИНН из ЕГРЮЛ",
			requiredInnForLegalPerson: "Введите ИНН для автоматического заполнения информации из ЕГРИП",
			requiredHeadSnils: "Введите СНИЛС сотрудника для добавления доверенности",
			requiredSnilsForAddEmployeeTrust: "Для добавления доверенности укажите СНИЛС сотрудника",
			reloadTrust: {
				ifReload: "Обратите внимание: загрузка новой доверенности приведет к аннулированию",
				current: "текущей"
			},
			notRightsToViewPage: "К сожалению, у вас нет доступа к данной странице",
			pageNotFound: "Страница, которую вы пытаетесь просмотреть, не найдена или доступ ограничен",
			internalServerError: "Произошла ошибка на стороне сервера. Пожалуйста, попробуйте позже",
			accessDenied: "Доступ запрещен. У вас нет соответствующих прав для выполнения этой операции",
			requestedPageNotFound: "Страница, которую вы ищете, не может быть найдена",
			legalPersonByInnNotFound: "Индивидуальный предприниматель с ИНН {inn} не найден",
			legalEntityByInnNotFound: "Не удалось найти организацию с ИНН {inn} в ЕГРЮЛ",
			masterAccountAccessApplicationExists: "Запрос на получение доступа к мастер-аккаунту уже был направлен и находится на рассмотрении. Результат будет направлен на указанный при подаче адрес электронной почты",
			employeeByEmailNotFound: "Сотрудник с таким адресом электронной почты не найден"
		},
		info: {
			additionalService: {
				part1: "Дополнительные услуги будут предложены контрагенту после заказа основных услуг.",
				part2: "Например, при оказании услуг бункеровки водой к обязательным дополнительным услугам относится аренда причала."
			},
			youCanSelectMultipleFloatingCranes: "Выберите плавкран",
			limitAmountCostExceeds: {
				part1: "Расчётная стоимость услуг превышает установленный лимит ({limitAmount}). Для продолжения оформления необходимо {agreementCreate}.",
				part2: "заключить договор"
			},
			guaranteeLetterNotAvailable: "Отправка заявки по гарантийному письму пока недоступна.",
			selectDivision: "Выбранное подразделение будет принимать решение по вашим заявкам",
			selectBranch: "Выбранный филиал будет принимать решение по вашим заявкам",
			createNewBranch: "Добавление нового филиала для {counterpartyName}",
			inputActualBankAccount: "Заполните актуальные банковские реквизиты вашей организации",
			checkBankAccount: "Проверьте актуальность банковского счета",
			applicationShipMismatch: "Обратите внимание: информация о судне в заявке не совпадает со сведениями в реестре.",
			noData: "Сведения отсутствуют",
			onSuccessCreated: "Сведения успешно сохранены",
			onSuccessUpdated: "Сведения успешно обновлены",
			onSuccessUploaded: "Документ успешно загружен",
			onSuccessStartCalibration: "Калибровка успешно запущена",
			settings: {
				successUpdated: "Сведения пользователя успешно обновлены"
			},
			inputSnilsOnAddTrust: {
				onAddTrust: "Для добавления доверенности укажите",
				inputSnils: "СНИЛС, ИНН и дату рождения сотрудника"
			},
			mchdRequiredDataMissingDialog: {
				title: "Необходимо заполнить данные сотрудника",
				paragraph1: "Для формирования МЧД необходимо заполнить обязательные сведения о сотруднике: ИНН, СНИЛС и дату рождения.",
				paragraph2: "Указанные данные используются при формировании и проверке МЧД в соответствии с требованиями законодательства Российской Федерации.",
				paragraph3: "Нормативные документы доступны по {0}.",
				paragraph3Link: "ссылке"
			},
			inputSnilsOnEnableElectronicSignatureSignIn: {
				onEnableElectronicSignatureSignIn: "Для подтверждения с помощью ЭП при входе необходимо указать",
				inputSnils: "СНИЛС"
			},
			organisationWasCreated: "Организация создана",
			youCanCloseCurrentBrowserPage: "Вы можете закрыть текущую страницу браузера",
			counterpartyBoatApplicationEdit: "Заявка будет рассмотрена сотрудником подразделения «{division}». При наличии документов на судно рекомендуется прикрепить их к заявке.",
			counterpartyBoatApplicationDetails: "Подтвердите, пожалуйста, корректность сведений о судне. При обнаружении неточностей воспользуйтесь формой редактирования.",
			counterpartyBoatApplicationDivisionRequired: "Чтобы продолжить оформление заявки необходимо указать подразделение. Для указания подразделения воспользуйтесь формой редактирования.",
			youCanSelectMultipleProperties: "Вы можете выбрать несколько объектов имущества для выполнения услуг",
			selectIcebreaker: "Выберите ледокол для выполнения услуг",
			servicesCostIsBasedOnActualData: "Указана предварительная стоимость услуг. Окончательная сумма может отличаться и будет рассчитана на основе фактических сведений после завершения оказания услуг.",
			noAgreements: "Чтобы создать заявку на оказание услуг, необходимо {0}.",
			selectedNoAgreementsDivision: "Для продолжения вам необходимо заключить договор на оказание услуг с одним из управлений.",
			agreementLimitAlmostExhausted: {
				part1: "Общая сумма оказанных в рамках договора услуг приближается к лимиту. Доступный остаток составляет {amount} ₽. Рекомендуется {agreementCreate}.",
				part2: "заключить новый договор"
			},
			agreementLimitExhausted: {
				part1: "Предварительная стоимость услуг превышает остаток по договору. Рекомендуется {agreementCreate}.",
				part2: "заключить новый договор"
			},
			agreementLimitFullyExhausted: {
				part1: "Лимит стоимости услуг по договору полностью исчерпан. Рекомендуется {agreementCreate}.",
				part2: "заключить новый договор"
			},
			agreementServiceAdvanceReached: "Достигнут минимально допустимый аванс для оказания услуг по договору. Для продолжения, пожалуйста, пополните баланс с помощью формы формирования счета на странице договора.",
			noActiveTrust: "Активная доверенность отсутствует.",
			timeSpentWillRound: "Затраченное время автоматически округляется в большую сторону с шагом 30 минут.",
			noTariffRateOrder: {
				noOrder: "Не нашли необходимый приказ?",
				addNewOrder: "Создать новый"
			},
			selectBoatOrAddBySearch: "Выберите судно из списка или добавьте в реестр используя функцию расширенного поиска",
			fillRequiredFieldsForCostCalculation: "Заполните необходимые сведения выше для расчета стоимости",
			isProcessedOutsideOfPortal: "Обработано вне Портала",
			noAvailableTariffsAlert: "Отсутствуют активные тарифы. Для продолжения необходимо добавить хотя бы один активный тариф."
		},
		saveChangesAlert: {
			title: "Сведения изменены",
			text: "Не забудьте сохранить их"
		}
	},
	buttons: {
		preview: "Предпросмотр",
		activate: "Активировать",
		deactivate: "Деактивировать",
		copy: "Скопировать",
		zoomIn: "Увеличить масштаб",
		zoomOut: "Уменьшить масштаб",
		previousPeriod: "Предыдущий период",
		nextPeriod: "Следующий период",
		expandDetails: "Показать подробности",
		collapseDetails: "Скрыть подробности",
		sendToDiadoc: "Отправить в Диадок",
		updateDocument: "Обновить документ",
		publish: "Опубликовать",
		addVersion: "Добавить версию",
		apply: "Применить",
		filters: "Фильтры",
		addGuaranteeLetterDefinition: "Добавить гарантийное письмо",
		publicServicesSignIn: "Войти через Госуслуги",
		addPublicOfferDefinition: "Добавить публичную оферту",
		selectAll: "Выбрать все",
		deselectAll: "Отменить все",
		goToCounterpartyHeadOrganization: "Детальный экран головной организации",
		addServiceDefinition: "Добавить услуги",
		addAdditionalService: "Добавить дополнительные услуги",
		profile: "Профиль",
		settings: "Настройки",
		notifications: "Уведомления",
		addPeriodOfUnavailability: "Добавить период недоступности",
		select: "Выбрать",
		deselect: "Снять выбор",
		editContact: "Изменить контакт",
		addWorkHour: "Добавить рабочее время",
		addContact: "Добавить контакт",
		addRole: "Добавить роль",
		addPort: "Добавить порт",
		addDepartment: "Добавить управление",
		addBranch: "Добавить филиал",
		advancedSearch: "Расширенный поиск",
		delete: "Удалить",
		resetTemplate: "Восстановить письмо",
		process: "Обработать",
		addTariff: "Добавить тариф",
		withdrawDocuments: "Отозвать расчетные документы",
		withdrawSign: "Отозвать электронную подпись",
		digitalSignatureInstructions: "Проблемы с электронной подписью?",
		instructions: "Инструкция",
		changeTariffs: "Внести изменения",
		downloadTemplate: "Скачать шаблон",
		generateFactureInvoice: "Сформировать счет-фактуру",
		generateInvoice: "Сформировать счет",
		generateUtd: "Сформировать УПД",
		downloadPrintForm: "Скачать печатную форму",
		downloadExample: "Скачать пример",
		signAgreement: "Подписать договор",
		signAccountingDocuments: "Подписать расчетные документы",
		downloadReport: "Скачать отчет",
		serviceProvided: "Завершить оказание услуг",
		approveAssignment: "Подтвердить назначение",
		changeResourceAssignment: "Изменить объект имущества",
		sign: "Подписать",
		saveSignature: "Скачать подпись",
		saveSignatures: "Скачать подписи",
		changeAccount: "Сменить аккаунт",
		clear: "Очистить",
		clearAll: "Очистить все",
		resetAll: "Сбросить всё",
		exportToExcel: "Экспортировать",
		accept: "Применить",
		choose: "Выбрать",
		signed: "Подписан",
		loadMore: "Загрузить еще",
		upload: "Загрузить",
		cancel: "Отменить",
		requestCancellation: "Запросить отмену",
		approveRequestCancellation: "Подтвердить запрос на отмену",
		rejectRequestCancellation: "Отклонить запрос на отмену",
		edit: "Редактировать",
		declineTrust: "Отменить одобрение",
		cancelTrust: "Отклонить",
		addTrust: "Добавить доверенность",
		skip: "Пропустить",
		save: "Сохранить",
		downloadTrustTemplate: "Скачать пример МЧД",
		close: "Закрыть",
		dontSave: "Не сохранять",
		ok: "Ок",
		backToList: "Назад к списку",
		add: "Добавить",
		remove: "Удалить",
		update: "Обновить",
		send: "Отправить",
		doNotSend: "Не отправлять",
		resend: "Отправить еще раз",
		back: "Назад",
		next: "Далее",
		logout: "Выйти",
		personalArea: "Личный кабинет",
		signIn: "Вход",
		account: "Пользователь",
		goToHome: "На главную",
		goToAccount: "Перейти к учетной записи",
		goTo: "Перейти",
		profileUser: "Профиль пользователя",
		restoreAccountAccess: "Восстановить доступ",
		continue: "Продолжить",
		esiaSignIn: "Войти с помощью госуслуг",
		resetPassword: "Сбросить пароль",
		addCounterparty: "Добавить контрагента",
		addHead: "Добавить руководителя",
		addEmployee: "Добавить сотрудника",
		addTariffRate: "Добавить тарифную ставку",
		recognize: "Распознать",
		addOffice: "Добавить предприятие",
		confirm: "Подтвердить",
		indicate: "Указать",
		change: "Изменить",
		updateViaFns: "Обновить из Контур.Фокус",
		toInvite: "Пригласить",
		updateAndSendCredentials: "Сформировать и отправить новые учётные сведения на почту",
		requestPhoneConfirmation: "Запросить подтверждение",
		create: "Создать",
		createBoat: "Создать судно",
		createAgreementLink: "Создать договор",
		createCounterpartyLink: "Создать контрагента",
		createDraft: "Создать черновик",
		createVersion: "Создать версию",
		saveAsDraft: "Сохранить как черновик",
		saveAsVersion: "Сохранить как версию",
		addNote: "Добавить запись",
		deleteNote: "Удалить запись",
		submitToAccounting: "Передать в бухгалтерию",
		submitTo1C: "Передать в 1C",
		accrueInterest: "Начислить проценты",
		signWithDigitalSignature: "Подписать",
		download: "Скачать",
		addManually: "Добавить вручную",
		additionalInterest: "Дополнительные проценты",
		recalculateInterest: "Переначислить проценты",
		massEdit: "Массовое редактирование",
		addInterest: "Добавить проценты",
		addPayment: "Добавить платеж",
		isForcedPayment: "Принудительное взыскание",
		importTreasuryStatement: "Импорт выписки",
		handleTreasuryStatement: "Обработать выписку",
		setTreasuryStatementRecordIsNotFinal: "Убрать п/п из обработанных",
		setTreasuryStatementRecordIsFinal: "Сохранить п/п",
		clearForm: "Очистить форму",
		finishProcessing: "Завершить обработку",
		more: "еще",
		moreServiceActions: "Ещё",
		serviceActions: "Действия",
		addDebtor: "Добавить должника",
		addFinalGoal: "Добавить конечную цель",
		goToSign: "Перейти к подписанию",
		generateAndSignMchd: "Сформировать и подписать МЧД",
		generateMchd: "Отправить на рассмотрение",
		submitTrustOriginal: "Передать оригиналы документов",
		search: "Поиск",
		generatePassport: "Генерация паспорта",
		digitalSignature: {
			isSigned: "Подтверждена с помощью электронной подписи руководителя",
			default: "Подтвердить с помощью электронной подписи руководителя"
		},
		goToAuthenticationPage: "Перейти на страницу аутентификации",
		addDocument: "Добавить документ",
		sendNewDocumentRequest: "Направить заявку на публикацию",
		sendChangeDocumentRequest: "Направить заявку на согласование",
		shareDocument: "Поделиться документом",
		createChangeRequest: "Заявка на изменение",
		rejectRequest: "Отклонить",
		acceptRequest: "Согласовать",
		forgotPassword: "Забыли пароль?",
		login: "Войти",
		registerOrganization: "Регистрация организации",
		confirmCode: "Подтвердить код",
		resendCode: "Выслать код повторно",
		resendInstructions: {
			long: "выслать инструкции ещё раз",
			short: "выслать ещё раз"
		},
		toSignIn: "К аутентификации",
		register: "Зарегистрироваться",
		addBankAccount: "Добавить счет",
		registerShip: "Зарегистрировать судно",
		archive: "Перенести в архив",
		unarchive: "Вынести из архива",
		registerCrewShip: "Зарегистрировать судно",
		addPier: "Добавить причал",
		addBoat: "Добавить судно",
		addShipowner: "Добавить судовладельца",
		addFlag: "Добавить флаг",
		addBoatType: "Добавить тип судна",
		formAccount: "Сформировать счет",
		concludeAgreement: "Заключить договор",
		approve: "Одобрить",
		decline: "Отклонить",
		addServices: "Добавить услуги",
		addAgreement: "Добавить договор",
		goToAgreementCreation: "Создать заявку",
		goToCounterpartyBoat: "Перейти к судну",
		leaveFeedback: "Оставить отзыв",
		repeatService: "Повторить услуги",
		repeatApplication: "Повторить заявку",
		orderServices: "Заказать услуги",
		newServices: "Создать заявку",
		createAgreement: "Добавить договор",
		addTugboat: "Добавить буксир",
		addIcebreaker: "Добавить ледокол",
		addEnvironmentalVessel: "Добавить судно экологического назначения",
		addHydrographicBoat: "Добавить гидрографический катер",
		addCrewboat: "Добавить судно",
		addFloatingCrane: "Добавить плавкран",
		assignTugboat: "Назначить буксиры",
		assignIcebreakers: "Назначить ледоколы",
		assignEnvironmentalVessels: "Назначить суда экологического назначения",
		assignHydrographicBoats: "Назначить гидрографические катера",
		assignCrewboat: "Назначить разъездные суда",
		assignFloatingCrane: "Назначить плавкраны",
		assignPier: "Назначить причал",
		assign: "Назначить",
		addServiceDocuments: "Загрузить расчетные документы",
		changeAccountingDocuments: "Изменить расчетные документы",
		downloadDocumentTemplate: "Скачать типовой документ",
		formAgreement: "Сформировать договор",
		addPortDestination: "Добавить место начала и окончания операции",
		goBack: "Вернуться",
		awaitingExecution: "Ожидают исполнения",
		addNewBoat: "Добавить новое судно",
		goToTariffApprovalOrdersSelection: "К выбору приказов",
		makeDefault: "Сделать по умолчанию",
		byDefault: "По умолчанию",
		updateDocumentTemplate: "Обновить шаблон",
		returnToStep: "Вернуться на шаг «{name}»"
	},
	common: {
		multiServicesAgreementAbbreviation: "РД",
		multiServicesAgreement: "Рамочный договор",
		yes: "Да",
		no: "Нет",
		port: "Порт",
		tugboat: "Буксир",
		crewboat: "Разъездное судно",
		pier: "Причал",
		floatingCrane: "Плавкран",
		icebreaker: "Ледокол",
		environmentalVessel: "Судно экологического назначения",
		hydrographicBoat: "Гидрографический катер",
		contactType: {
			Phone: "Номер телефона",
			Email: "Электронная почта",
			Fax: "Факс",
			Vhf: "Радиосвязь",
			Other: "Другой"
		},
		phone: {
			part1: "Номер: {value}",
			part2: "Доб. номер: {value}"
		},
		workHours: "{day}: {startTime} - {endTime} ({note})",
		contactValidationPeriod: {
			part1: "С {validFrom}",
			part2: "по {validTo}"
		},
		vhf: {
			part1: "Каналы: {vhfChannels}; ",
			part2: "Позывной: {vhfCallsign}"
		},
		balance: "Баланс",
		welcome: "Здравствуйте, {name}",
		till: "до",
		signedBy: {},
		signature: "(подпись)",
		callSign: "Позывной",
		flag: "Флаг",
		fullYear: "Год",
		grt: "GRT",
		myDocuments: "Мои документы",
		fileMustNotBeEmpty: "Файл не может быть пустым",
		wrongCode: "Код неверный",
		vatIncluded: "в.т.ч. НДС",
		or: "или",
		legalPerson: "ИП",
		certificatesLength: "Число сертификатов",
		noData: "Отсутствуют сведения",
		createBoatApplicationInfo: "Для добавления судна в ваш реестр укажите сведения для его поиска в справочнике судов Портала услуг ФГУП «Росморпорт». В случае отсутствия судна в справочнике, потребуется заполнить сведения вручную.",
		masterAccountEmailFormText: {
			successText: "На указанный адрес электронной почты направлено письмо с доступом к мастер-аккаунту.",
			editModeText: "Укажите адрес электронной почты. На этот адрес будет направлено письмо с доступом к мастер-аккаунту."
		},
		accountEmailFormText: {
			changeEmailSuccessText: "На указанный адрес электронной почты отправлено письмо со ссылкой для подтверждения.",
			editModeText: "Укажите новый адрес электронной почты. На этот адрес будет направлено письмо со ссылкой для подтверждения или же новые учётные сведения для входа."
		},
		accountPasswordFormText: {
			changePasswordSuccessText: "Пароль успешно изменён. На указанный адрес электронной почты было направлено письмо с новым временным паролем.",
			editModeText: "Укажите новый пароль. После изменения на указанный адрес электронной почты будет направлено письмо с временным паролем."
		},
		masterAccountAccessContactInformationStep: {
			stepOne: "Регистрация организации доступна для юридических лиц и индивидуальных предпринимателей, входящих в реестры ЕГРЮЛ и ЕГРИП Федеральной налоговой системы. Введенный ИНН используется для получения сведений об организации из ЕГРЮЛ и ЕГРИП с целью верификации и автоматического заполнения сведений.",
			subtitleOne: "Если при вводе ИНН организации возникает ошибка, обратитесь в службу технической поддержки по электронной почте: ",
			stepTwo: "На указанный адрес электронной почты будут направлены сведения для входа в аккаунт организации.",
			subtitleTwo: "Аккаунт организации позволяет вести реестр сотрудников: добавлять, редактировать, активировать и деактивировать. Используя такой аккаунт, нельзя заказать услуги или завести договор – для этого необходимо добавить сотрудника организации."
		},
		masterAccountAccessDocumentsStep: {
			toConfirmRightPerformActionsOnBehalfOf: "Для подтверждения права на выполнение действий от имени",
			legalEntity: "юридического лица",
			legalPerson: "индивидуального предпринимателя",
			attachDocumentsListBelow: "приложите перечень указанных ниже документов"
		},
		masterAccountAccessFinalStep: {
			default: "Результаты рассмотрения заявки будут направлены на указанный адрес электронной почты."
		},
		numbers: {
			adjectives: {
				"1": "Первый",
				"2": "Второй",
				"3": "Третий",
				"4": "Четвертый",
				"5": "Пятый",
				"6": "Шестой",
				"7": "Седьмой"
			}
		},
		emptyFileName: "Файл без названия",
		documentFromDate: "{number} от {date}",
		missing: "Отсутствует",
		tooltipTextSnils: "СНИЛС используется для проверки электронной подписи сотрудника в рамках верификации полномочий по машиночитаемой доверенности (МЧД)",
		tooltipTextDateOfBirth: "Дата рождения используется для проверки электронной подписи сотрудника в рамках верификации полномочий по машиночитаемой доверенности (МЧД)",
		tooltipTextInn: "ИНН используется для проверки электронной подписи сотрудника в рамках верификации полномочий по машиночитаемой доверенности (МЧД)",
		tooltipTextIsPublicContact: "Контрагенты видят только контакты с включённым переключателем. В выключенном состоянии контакт доступен только сотрудникам.",
		tooltipTextContactPriority: "Порядок вывода в списке: чем больше приоритет, тем выше контакт.",
		tooltipTextContactValidTo: "Дата, после которой контакт перестанет считаться актуальным и не будет показываться другим пользователям. Оставьте пустым, если контакт бессрочный.",
		tooltipTextContactValidFrom: "Дата, с которой контакт начнет считаться актуальным и будет показываться другим пользователям.",
		tooltipTestPortTariff: "Укажите порт, если тариф будет действовать исключительно в отношении услуг, оказываемых в данном порту. При пустом значении тариф распространяется на все порты подразделения",
		inn: "ИНН",
		ogrn: "ОГРН",
		lastAssessmentHint: "Типы последней оценки: [д] – договор, [с] - решение суда, [т] - результат торгов, [п] - результат переоценки",
		inMillionRubles: "млн. руб",
		counterpartyIsMissing: "Отсутствует необходимый контрагент?",
		signTrustOptions: {
			title: "Вы можете подписать доверенность одним из указанных способов:",
			option1: {
				title: "1. “Подписать электронной подписью”",
				text: "При выборе этого варианта сотрудники ФГУП «Росморпорт» рассматривают доверенность в течение двух рабочих дней. О результате рассмотрения пользователю приходит письмо на почту."
			},
			option2: {
				title: "2. “Передать документы”",
				text: "В случае, если у руководителя отсутствует возможность подписать доверенность электронной подписью, то для ее рассмотрения необходимо передать оригиналы документов в ближайшее управление ФГУП «Росморпорт». Контактная информация по ",
				link: "ссылке"
			}
		},
		uploadTrustHint: {
			title: "Загрузка машиночитаемой доверенности",
			subtitle: "Для подписания документов электронной подписью сотрудника организации необходимо добавить МЧД на его имя.",
			previewHint: "Предварительный просмотр МЧД для проверки данных перед подписанием",
			signingMethod: "Способ оформления",
			signingOptions: {
				director: {
					label: "Подписать ЭП директора",
					description: "Подразделение не выбирается. Доверенность рассматривается автоматически.",
					alertTitle: "Рассмотрение не требуется",
					alertText: "После нажатия «Сформировать и подписать МЧД» откроется окно выбора сертификата электронной подписи директора."
				},
				originals: {
					label: "Передать оригиналы документов",
					description: "Выберите подразделение, которое будет рассматривать доверенность.",
					alertTitle: "Оригиналы документов рассмотрит подразделение",
					alertText: "Выберите подразделение для передачи оригиналов документов и рассмотрения доверенности."
				}
			},
			steps: "Что нужно сделать:",
			step1: "1. Заполнить шаблон доверенности, подписать у руководителя организации;",
			step2: "2. Подписанную доверенность необходимо отсканировать вместе с приложениями и загрузить на Портал."
		},
		trustAuthorities: {
			title: "Полномочия сотрудника",
			subtitle: "Выберите перечень полномочий, которые будут доступны сотруднику вашей организации в рамках оформляемой МЧД.",
			contractSigning: "подписание договоров и доп. соглашений",
			primaryDocsSigning: "подписание первичных документов"
		},
		noSigningAuthorityHint: "Для подписания документов от имени организации необходимо войти под учетной записью генерального директора или добавить выбранному сотруднику доверенность.",
		// TODO: текст временный
		createServiceApplicationRequiredStepsHint: {
			step1: {
				title: "Шаг 1: Подготовка необходимых документов и прав",
				text1: "1.1. Перед началом процесса подачи заявки убедитесь, что у вас есть право осуществлять действия от лица генерального директора вашей организации.",
				text2: "1.2. Для подписи документов, связанных с буксирными услугами, вы можете использовать электронную подпись генерального директора. Если у вас нет электронной подписи, необходимо предоставить доверенность, разрешающую осуществление данного действия."
			},
			step2: {
				title: "Шаг 2: Проверка прав контрагента",
				text1: "2.1. Убедитесь, что у вашего контрагента (поставщика буксирных услуг) есть право на буксировку судна.",
				text2: "2.2. В случае, если у контрагента нет необходимых прав, перейдите по {url}."
			},
			step3: {
				title: "Шаг 3: Заключение договора",
				text1: "3.1. Для заключения договора на оказание буксирных услуг, перейдите по {url}.",
				text2: "3.2. Прочтите и ознакомьтесь с условиями договора и необходимыми документами.",
				text3: "3.3. Заполните все необходимые поля в заявке, включая информацию о ваших контактных сведениях и деталях буксировки.",
				text4: "3.4. Прикрепите к заявке копии необходимых документов, включая свидетельство о праве плавания под флагом (если требуется)."
			},
			step4: {
				title: "Шаг 4: Подача заявки",
				text1: "4.1. Перейдите на официальный веб-сайт контрагента или организации, предоставляющей буксирные услуги.",
				text2: "4.2. На сайте найдите раздел \"Подача заявки на буксировку\" или аналогичный, и следуйте инструкциям для заполнения и отправки заявки.",
				text3: "4.3. Убедитесь, что все ваши сведения и документы прикреплены правильно и полностью.",
				text4: "4.4. Ожидайте подтверждения заявки от контрагента или управления буксировки судов."
			},
			summary: "Следуя этой инструкции, вы сможете подать заявку на оказание буксирных услуг, удостоверившись в наличии необходимых прав и документов. Не забывайте следовать официальным источникам и ресурсам при подаче заявки и заключении договоров.",
			link: "ссылке"
		},
		signatureIsMissing: "Электронная подпись отсутствует",
		helpWorkWithDigitalSignature: "Справка по работе с электронной подписью",
		unPublished: "Документ снят с публикации",
		allFinanceSchemes: "Все программы",
		help: "Справка",
		confirmEmailFormText: {
			successText: "Вы будете автоматически перенаправлены на страницу аутентификации через: {seconds}.",
			editModeText: "На адрес электронной почты отправлено письмо с кодом подтверждения"
		},
		confirmPhoneFormText: {
			successText: "Номер телефона подтвержден, вы можете перейти в личный кабинет",
			editModeText: "На номер телефона отправлено письмо с кодом подтверждения"
		},
		forgotPasswordFormText: {
			successText: {
				part1: "Если аккаунт",
				part2: "активен, на почту будет отправлено письмо с инструкцией для сброса пароля"
			}
		},
		resetPasswordFormText: {
			successText: "Вы будете автоматически перенаправлены на страницу аутентификации через: {seconds}."
		},
		setPasswordFormText: {
			successText: "Пароль установлен, вы можете перейти в личный кабинет"
		},
		selectProfileText: "Выберите необходимый профиль для работы в системе:",
		resendCodeAfter: "Выслать код повторно через:",
		resendInstructionsAgainAfter: "Выслать инструкции повторно через:",
		seconds: "с",
		year: "г",
		itemNotInList: {
			title: "Отсутствует в списке",
			warning: "Не указано место начала или окончания операции. Для уточнения информации, пожалуйста, после отправки заявки перейдите в раздел «Комментарии» и добавьте комментарий с необходимыми сведениями о месте начала или окончания операции."
		},
		parameterChangeWithPreviousAndCurrent: "{parameter} (было: {previous}, стало: {current})",
		fieldDifferences: "Различия в полях: ",
		notSpecified: "Не указано",
		missingData: "Сведения отсутствуют",
		includingDivisions: " | включая {divisions} | включая управления: {divisions}",
		goToAdminPanel: "Для просмотра перейдите в ЛК администратора"
	},
	instructions: {
		agreement: {
			heading: "Инстуркция по оформлению заявки на договор",
			steps: {
				step1: {
					title: "Шаг 1: Подготовка необходимых документов и прав",
					content: "Перед началом подачи заявки убедитесь, что у вас есть право осуществлять действия от лица генерального директора вашей организации. " +
						"Для подписи документов, связанных с договором на оказание услуг, вы можете использовать электронную подпись генерального директора." +
						" Если у вас нет электронной подписи генерального директора, необходимо предоставить доверенность, позволяющую совершать соответствующие действия от имени генерального директора. " +
						"Загрузить доверенность можно через аккаунт организации, открыв вкладку \"Доверенности\" в профиле нужного сотрудника."
				},
				step2: {
					title: "Шаг 2: Заказ услуг ФГУП «Росморпорт».",
					content: {
						part1: "Выберите тип услуг и подразделение ФГУП «Росморпорт», с которым будет заключен договор на оказание услуг;",
						part2: "Подтвердите правильность введенных сведений об организации;",
						part3: "Укажите банковские реквизиты;",
						part4: "Загрузите необходимые документы;",
						part5: "Подтвердите правильность введенных сведений о договоре, после подтверждения сведения будут направлены на рассмотрение сотрудникам ФГУП «Росморпорт». " +
							"Информация об одобрении или отклонении услуг будет направлена вам на текущую электронную почту и в личный кабинет Портала услуг. " +
							"Для коммуникации с сотрудниками ФГУП «Росморпорт» используйте вкладку \"Комментарии\" – вы также будете получать уведомления о новых сообщениях на электронную почту."
					}
				}
			}
		},
		service: {
			heading: {
				[ApiServiceType.PierService]: "Инструкция для услуг по предоставлению причала для стоянки судов:",
				[ApiServiceType.TugService]: "Инструкция для буксирных услуг:",
				[ApiServiceType.InformationService]: "Инструкция для информационных услуг:",
				[ApiServiceType.CrewBoatService]: "Инструкция для услуг по предоставлению разъездных судов:",
				[ApiServiceType.FloatingCraneService]: "Инструкция для услуг по предоставлению плавкранов:",
				[ApiServiceType.DredgingService]: "Инструкция для дноуглубительных услуг:",
				[ApiServiceType.SnoInstallationService]: "Инструкция для услуг по установке и обслуживанию СНО:",
				[ApiServiceType.GeodeticHydrographicService]: "Инструкция для геодезических и гидрографических услуг:",
				[ApiServiceType.DeviationRemoval]: "Инструкция для услуг по устранению/уничтожению девиации:",
				[ApiServiceType.IcePilotService]: "Инструкция для услуг по предоставлению ледовых лоцманов:",
				[ApiServiceType.PilotTransfer]: "Инструкция для услуг по доставке лоцманов:",
				[ApiServiceType.LinkspanBridge]: "Инструкция для услуг по стыковке-расстыковке морских судов с подъемно-переходным мостом:",
				[ApiServiceType.Ecological]: "Инструкция для экологических услуг:",
				[ApiServiceType.DrinkingWater]: "Инструкция для услуг по бункеровке судов питьевой водой:",
				[ApiServiceType.IndividualIcebreakerAssistance]: "Инструкция для услуг по индивидуальной ледокольной проводке:",
				[ApiServiceType.Consulting]: "Инструкция для консультационных услуг:",
				[ApiServiceType.Icebreaking]: "Инструкция для ледокольных услуг:"
			},
			steps: {
				step1: {
					title: "Шаг 1: Подготовка необходимых документов и прав.",
					content: {
						part1: "Перед началом подачи заявки убедитесь, что у вас есть право осуществлять действия от лица генерального директора вашей организации. Для подписи документов, связанных с {0}, вы можете использовать электронную подпись генерального директора. Если у вас нет электронной подписи генерального директора, необходимо предоставить доверенность, позволяющую совершать соответствующие действия от имени генерального директора.Загрузить доверенность можно через аккаунт организации, открыв вкладку \"Доверенности\" в профиле нужного сотрудника.",
						part2: {
							[ApiServiceType.PierService]: "услугами по предоставлению причалов для стоянки судов",
							[ApiServiceType.TugService]: "буксирными услугами",
							[ApiServiceType.InformationService]: "информационными услугами",
							[ApiServiceType.CrewBoatService]: "услугами по предоставлению разъездных судов",
							[ApiServiceType.FloatingCraneService]: "услугами плавкрана",
							[ApiServiceType.DredgingService]: "дноуглубительными услугами",
							[ApiServiceType.SnoInstallationService]: "услугами по установке и обслуживанию СНО",
							[ApiServiceType.GeodeticHydrographicService]: "геодезическими и гидрографическими услугами",
							[ApiServiceType.DeviationRemoval]: "услугами по устранению/уничтожению девиации",
							[ApiServiceType.IcePilotService]: "услугами по предоставлению ледовых лоцманов",
							[ApiServiceType.PilotTransfer]: "услугами по доставке лоцманов",
							[ApiServiceType.LinkspanBridge]: "услугами по стыковке-расстыковке морских судов с подъемно-переходным мостом",
							[ApiServiceType.Ecological]: "экологическими услугами",
							[ApiServiceType.DrinkingWater]: "услугами по бункеровке судов питьевой водой",
							[ApiServiceType.IndividualIcebreakerAssistance]: "услугами по индивидуальной ледокольной проводке",
							[ApiServiceType.Consulting]: "консультационными услугами",
							[ApiServiceType.Icebreaking]: "ледокольными услугами"
						},
						part3: "Убедитесь, что у вас заключен договор на оказание {service} с нужным управлением ФГУП «Росморпорт». Если у вас нет заключенного договора, перейдите по {create} для его создания.",
						part4: {
							[ApiServiceType.PierService]: "услуг по предоставлению причалов для стоянки судов",
							[ApiServiceType.TugService]: "буксирных услуг",
							[ApiServiceType.InformationService]: "информационных услуг",
							[ApiServiceType.CrewBoatService]: "услуг по предоставлению разъездных судов",
							[ApiServiceType.FloatingCraneService]: "услуг по предоставлению плавкранов",
							[ApiServiceType.DredgingService]: "дноуглубительных услуг",
							[ApiServiceType.SnoInstallationService]: "услуг по установке и обслуживанию СНО",
							[ApiServiceType.GeodeticHydrographicService]: "геодезических и гидрографических услуг",
							[ApiServiceType.DeviationRemoval]: "услуг по устранению/уничтожению девиации",
							[ApiServiceType.IcePilotService]: "услуг по предоставлению ледовых лоцманов",
							[ApiServiceType.PilotTransfer]: "услуг по доставке лоцманов",
							[ApiServiceType.LinkspanBridge]: "услуг по стыковке-расстыковке морских судов с подъемно-переходным мостом",
							[ApiServiceType.Ecological]: "экологических услуг",
							[ApiServiceType.DrinkingWater]: "услуг по бункеровке судов питьевой водой",
							[ApiServiceType.IndividualIcebreakerAssistance]: "услуг по индивидуальной ледокольной проводке",
							[ApiServiceType.Consulting]: "консультационных услуг",
							[ApiServiceType.Icebreaking]: "ледокольных услуг"
						},
						part5: "ссылке",
						part6: "Убедитесь, что в разделе {boats} добавлено судно, которому необходимы услуги. Если нужное судно еще не добавлено на Портал, перейдите по {add} и следуйте дальнейшим инструкциям.",
						part7: "Мой флот"
					}
				},
				step2: {
					title: "Шаг 2: Заказ услуг ФГУП «Росморпорт».",
					content: {
						part1: "Выберите тип услуг;",
						part2: "Выберите управление ФГУП «Росморпорт», которым будут оказаны услуги;",
						part3: "Выберите порт, которым будут оказаны услуги, этот шаг не является обязательным к заполнению;",
						part4: "Выберите один из ранее заключенных с ФГУП «Росморпорт» договоров на оказание услуг;",
						part5: "Выберите одно или два из ранее добавленных на Портал ФГУП «Росморпорт» судов, которым необходимы оказываемые услуги;",
						part6: {
							[ApiServiceType.PierService]: "Выберите один или несколько предпочтительных причалов. Этот шаг не является обязательным к заполнению. Финальное решение по назначению причала принимает сотрудник ФГУП «Росморпорт»;",
							[ApiServiceType.LinkspanBridge]: "Выберите один или несколько предпочтительных причалов. Этот шаг не является обязательным к заполнению. Финальное решение по назначению причала принимает сотрудник ФГУП «Росморпорт»;",
							[ApiServiceType.PilotTransfer]: "Выберите одно или несколько предпочтительных разъездных судов. Этот шаг не является обязательным к заполнению. Финальное решение по назначению разъездного судна принимает сотрудник ФГУП «Росморпорт»;",
							[ApiServiceType.TugService]: "Выберите один или несколько предпочтительных буксиров. Этот шаг не является обязательным к заполнению. Финальное решение по назначению буксира принимает сотрудник ФГУП «Росморпорт»;",
							[ApiServiceType.IndividualIcebreakerAssistance]: "Выберите один или несколько предпочтительных ледоколов. Этот шаг не является обязательным к заполнению. Финальное решение по назначению ледокола принимает сотрудник ФГУП «Росморпорт»;",
							[ApiServiceType.FloatingCraneService]: "Выберите один предпочтительный плавкран. Этот шаг не является обязательным к заполнению. Финальное решение по назначению плавкрана принимает сотрудник ФГУП «Росморпорт»;",
							[ApiServiceType.CrewBoatService]: "Выберите одно или несколько предпочтительных разъездных судов. Этот шаг не является обязательным к заполнению. Финальное решение по назначению разъездного судна принимает сотрудник ФГУП «Росморпорт»;",
							[ApiServiceType.Ecological]: "Выберите одно или несколько предпочтительных судов экологического назначения. Этот шаг не является обязательным к заполнению. Финальное решение по назначению судна экологического назначения принимает сотрудник ФГУП «Росморпорт»;",
							[ApiServiceType.GeodeticHydrographicService]: "Выберите один или несколько предпочтительных гидрографических катеров. Этот шаг не является обязательным к заполнению. Финальное решение по назначению гидрографического катера принимает сотрудник ФГУП «Росморпорт»;"
						},
						part7: "Выберите один или несколько предпочтительных тарифов. Этот шаг не является обязательным к заполнению. Финальное решение по назначению тарифов принимает сотрудник ФГУП «Росморпорт»;",
						part8: "Введите информацию о дате и времени",
						part9: "Ознакомьтесь с предварительной стоимостью выбранных услуг. Финальная стоимость определяется по факту оказания услуг и может отличаться от предварительной;",
						part10: "Проверье и прикрепите необходимые документы;",
						part11: "Подтвердите правильность введенных сведений о заказываемых услугах, после подтверждения сведения будут направлены на рассмотрение сотрудникам ФГУП «Росморпорт». Информация об одобрении или отклонении услуг будет направлена вам на текущую электронную почту и в личный кабинет Портала услуг. Для коммуникации с сотрудниками ФГУП «Росморпорт» используйте вкладку \"Комментарии\" – вы также будете получать уведомления о новых сообщениях на электронную почту."
					}
				}
			}
		}
	},
	dialogs: {
		filters: {
			title: "Фильтры",
			groups: {
				counterpartyType: "Тип контрагента",
				service: "Услуги",
				status: "Статусы",
				branch: "Филиалы",
				department: "Управления"
			},
			subheaders: {
				department: "Выберите управление",
				branch: "Выберите филиал",
				port: "Выберите порт",
				status: "Выберите статус",
				counterpartyType: "Выберите тип контрагента",
				service: "Выберите услуги",
				division: "Выберите подразделение"
			}
		},
		selectRole: {
			title: "Выберите роль"
		},
		deleteContactConfirm: {
			title: "Удалить контакт",
			text: "Вы действительно хотите удалить контакт? Данное действие невозможно будет восстановить."
		},
		schemaViewer: {
			title: "Просмотр схемы"
		},
		filePreview: {
			title: "Предпросмотр",
			loading: "Загрузка документа",
			fitToScreen: "Показать целиком",
			rotate: "Повернуть",
			downloadFile: "Скачать файл"
		},
		subject: {
			title: "Изменить тему письма"
		},
		deleteConfirm: {
			title: "Удалить запись",
			text: "Вы действительно хотите удалить запись? Данное действие невозможно будет восстановить."
		},
		resetTemplate: {
			title: "Восстановить письмо",
			text: "Вы действительно хотите восстановить письмо до стандартного шаблона? Все внесённые изменения будут утеряны."
		},
		bankAccountDialog: {
			title: "Удаление счета",
			text: "Вы действительно хотите удалить счет {accountNumber}?"
		},
		archiveConfirm: {
			title: "Подтвердите перенос объекта в архив",
			text: "Обратите внимание, что после архивации объект будет недоступен для осуществления любых операций, но его можно будет восстановить в любой момент.\nВы уверены, что хотите продолжить?",
			noRestoreText: "Обратите внимание, что после архивации объект будет недоступен для осуществления любых операций. Вы уверены, что хотите продолжить?"
		},
		returnToStepConfirm: {
			text: "Подтвердите возврат на шаг «{name}». В случае подтверждения данного действия, будет выполнен возврат на предыдущий шаг. Вы уверены, что хотите продолжить?"
		},
		deleteDraft: {
			title: "Обработка черновика завершена",
			text: "Судно успешно добавлено в реестр. Рекомендуется удалить черновик, чтобы избежать его случайного повторного использования.",
			delete: "Удалить черновик",
			cancel: "Оставить черновик"
		},
		counterpartySendDocumentsConfirm: {
			accountingDocuments: {
				title: "Расчетные документы подписаны",
				text: "Вы завершили подписание расчетных документов по оказанным услугам. Отправить их на рассмотрение в ФГУП «Росморпорт»?"
			},
			agreement: {
				title: "Договор подписан",
				text: "Вы завершили подписание договора. Отправить договор на рассмотрение в ФГУП «Росморпорт»?"
			}
		},
		digitalSignatureInstructions: {
			title: "Проблемы с электронной подписью"
		},
		passwordExpiration: {
			title: "Рекомендуется изменить ваш пароль",
			description: "Число дней до истечения срока действия пароля: {days}. После истечения срока действия доступ к аккаунту будет потерян.",
			accept: "Сменить пароль",
			cancel: "Позже"
		},
		declineBoatApplication: {
			title: "Отклонить заявку на судно"
		},
		declineServiceApplication: {
			title: "Отклонить услуги"
		},
		cancelServiceApplication: {
			title: "Подтвердите отмену услуг"
		},
		requestServiceCancellation: {
			title: "Подтвердите запрос на отмену услуг"
		},
		rejectCancellationRequest: {
			title: "Отклонить запрос на отмену услуг"
		},
		declineEmployeeJoin: {
			title: "Отклонить заявку на прикрепление сотрудника к организации"
		},
		confirmCancelFormChanges: {
			title: "Отменить изменения?",
			description: "Последние изменения не были сохранены, сведения могут быть утеряны."
		},
		confirmOperationWithUnsavedChanges: {
			title: "Изменения будут утеряны",
			description: "Последние изменения не были сохранены, выполнение операции приведет к их утере. Вы действительно хотите продолжить?"
		},
		confirmUnsavedChanges: {
			title: "Сохранить изменения?",
			description: "Форма содержит несохраненные изменения"
		},
		acceptUnappliedChanges: {
			title: "Предупреждение",
			description: "Система не сохранила некоторые из параметров",
			accept: "Понятно"
		},
		datePicker: {
			submit: "Подтвердить",
			cancel: "Отмена"
		},
		resetPassword: {
			title: "Сбросить пароль",
			description: "На указаную вами почту придет письмо с дальнейшими инструкциями по смене пароля"
		},
		deleteNote: {
			title: "Удалить запись",
			warning: "Вы действительно хотите удалить запись? Данное действие невозможно будет восстановить."
		},
		deletePayment: {
			title: "Удалить платеж",
			warning: "Вы действительно хотите удалить платеж? После подтверждения удаления отменить действие будет невозможно."
		},
		deleteDivision: {
			title: "Удалить подразделение",
			warning: "Вы действительно хотите удалить подразделение? После подтверждения удаления отменить действие будет невозможно."
		},
		deleteCounterparty: {
			title: "Удалить контрагента",
			warning: "Вы действительно хотите удалить контрагента? После подтверждения удаления отменить действие будет невозможно."
		},
		masterApplicationExists: {
			title: "Открыта заявка на мастер-аккаунт",
			warning: "По выбранному контрагенту существует открытая заявка на получение доступа к мастер-аккаунту. Перед внесением изменений в данные контрагента рекомендуется завершить обработку заявки."
		},
		deleteRole: {
			title: "Удалить роль",
			warning: "Вы действительно хотите удалить роль? После подтверждения удаления отменить действие будет невозможно."
		},
		updateNotActiveAgreementStatus: {
			title: "Вы действительно хотите завершить действие договора?",
			warning: "Данное действие нельзя будет отменить, оформление услуг по данному договору станет невозможным."
		},
		masterAccountExit: {
			title: "Сменить аккаунт?",
			content: {
				part1: "Ваш аккаунт организации предоставляет возможность управлять реестром сотрудников: вы можете добавлять новых сотрудников редактировать их сведения, а также активировать или деактивировать их учетные записи.",
				part2: "Чтобы сотрудник мог подписывать договоры и расчетные документы от имени организации, убедитесь, что для него {0}.",
				part3: "добавлена доверенность"
			}
		},
		declineTrust: {
			title: "Подтвердите отклонение доверенности"
		},
		declineApplication: {
			title: "Подтвердите отклонение запроса"
		},
		addDocument: {
			title: "Добавить документ"
		},
		deleteBranchConfirm: {
			title: "Удалить филиал",
			text: `Вы действительно хотите удалить "{branch}"?`
		},
		deleteAdditionalService: {
			title: "Удалить дополнительные услуги",
			warning: "Вы действительно хотите удалить дополнительные услуги? Данное действие невозможно будет восстановить."
		},
		addBranch: {
			title: "Добавить филиал",
			multipleTitle: "Добавить филиалы",
			description: "Выберите один или несколько филиалов.",
			defaultBranchLabel: "Филиал по умолчанию",
			defaultBranchPlaceholder: "Выберите филиал",
			defaultBranchHint: "Выберите один из отмеченных филиалов."
		},
		selectBranch: {
			title: "Выбор филиала",
			rememberChoice: "Запомнить выбор"
		},
		snilsRequiredForSigning: {
			title: "Подписание документов",
			description: "Для подписания документов от имени предприятия требуется проверка электронной подписи. Пожалуйста, укажите СНИЛС сотрудника."
		}
	},
	tooltips: {
		counterpartyEdoFnsParticipantId: "Уникальный код участника электронного документооборота в Контур.Диадок. Идентификатор можно узнать у сотрудника вашей организации, который работает в Диадоке.",
		additionalServiceRequired: "При включении дополнительные услуги будут обязательны при заказе основных услуг.",
		portParent: "Подразделение, к которому относится данный порт",
		portCode: "Код, используемый для идентификации порта в корпоративной информационной системе",
		division: "Подразделение, в рамках которого применяется данный тариф",
		propertyName: "Объект имущества, к которому применяется данный тариф при оказании услуг",
		axapta: "Код, используемый для учета причала в корпоративной информационной системе",
		propertyDivision: "Сведения о подразделении, в ведении которых находится объект имущества",
		boatCode: "Код, используемый для идентификации типа судна при интеграции со смежными системами",
		boatName: "Наименование типа судна",
		initiatorCounterparty: "Судовладелец или судовой агент, создавший заявку",
		counterpartyBoatDetails: "Судовладелец или судовой агент, создавший заявку",
		additionalDivisions: "Перечень подразделений, в рамках которых пользователям с данной ролью предоставляется право доступа для выполнения операций",
		code: "Код, используемый для идентификации подразделения в корпоративной информационной системе",
		roles: "Роли определяют участие пользователя в процессах оказания услуг и набор доступных операций, назначаемых администратором",
		ports: "Порты, в которых доступны данные услуги",
		signIn: "Для входа в личный кабинет введите адрес электронной почты зарегистрированного пользователя от организации. Для входа в мастер-аккаунт введите ИНН организации",
		download: "Скачать",
		archive: "Перенести в архив",
		unarchive: "Вернуть из архива",
		awaitingConfirmation: "На подтверждении сотрудником ФГУП «Росморпорт»",
		createRequestFromCopy: "Создать заявку из копии",
		resetTemplate: "Восстановить шаблон по умолчанию",
		serviceWorkflow: {
			nextStep: "Следующий шаг"
		},
		agreementWorkflow: {
			nextStep: "Следующий шаг"
		}
	},
	errorsPages: {
		pageNotFound: "Что-то пошло не так, давайте попробуем сначала!",
		internalServer: "500 (Ошибка сервера)"
	},
	placeholders: {
		search: "Поиск",
		email: "email@mail.ru",
		password: "Введите пароль",
		request: "Введите запрос",
		dateMask: "дд.мм.гггг"
	},
	hints: {
		range: "Диапазон значений от {min} до {max}"
	},
	logs: {
		error: {
			requestError: "Ошибка выполнения запроса"
		},
		info: {
			request: "Запрос {url}",
			response: "Ответ {url}"
		}
	},
	navigation: {
		applications: {
			index: "Запросы и обращения",
			masterAccountAccess: "Доступ к мастер-аккаунту",
			employeeJoin: "Прикрепление к организации"
		},
		admin: {
			index: "Администрирование",
			counterparties: "Контрагенты",
			counterpartiesList: "Список",
			counterparty: "Контрагент",
			offices: "Предприятия",
			accounts: "Пользователи",
			applications: "Запросы",
			branches: "Филиалы",
			departments: "Управления",
			rmp: "ФГУП «Росморпорт»",
			ports: "Порты",
			employees: "Сотрудники",
			roles: "Роли",
			head: "Центральный аппарат",
			templates: "Письма",
			contacts: "Контакты"
		},
		counterparty: {
			dashboard: "Панель управления",
			documents: "Мои документы",
			boatApplications: "Мой флот",
			agreements: "Мои договоры",
			services: "Мои услуги",
			dispatcherContacts: "Контакты диспетчерской",
			settings: "Настройки"
		},
		enterprise: {
			publicOfferDefinitions: "Оферты",
			dispatcherContacts: "Контакты диспетчерской",
			dashboard: "Панель управления",
			tugBoats: "Буксиры",
			icebreakers: "Ледоколы",
			environmentalVessels: "Суда экологического назначения",
			hydrographicBoats: "Гидрографические катера",
			crewBoats: "Разъездные суда",
			floatingCranes: "Плавкраны",
			piers: "Причалы",
			ports: "Порты",
			services: "Услуги",
			counterparties: "Контрагенты",
			boatsInfo: "Справочник судов",
			boatApplications: "Суда от контрагентов",
			metrics: "Статистика",
			agreements: "Договоры",
			tariffs: "Тарифы",
			boats: "Справочник",
			boatsDraft: "Импорт",
			flags: "Флаги",
			shipowners: "Судовладельцы",
			boatTypes: "Типы судов"
		},
		finance: {
			title: "Финансовый блок"
		},
		procuring: {
			title: "Обеспечение"
		},
		support: {
			title: "Техподдержка"
		},
		common: {
			legalEntity: "Организации",
			users: "Пользователи",
			propertyAssets: "Объекты имущества",
			handbooks: "Справочники"
		},
		breadcrumbs: {},
		documents: "Реестр документов",
		requests: "Реестр заявок на изменение"
	},
	subheaders: {
		versions: "Версии",
		acceptances: "Акцепты",
		operations: "Операции",
		guaranteeLetterDefinitionDocumentTemplate: "Шаблон документа гарантийного письма",
		guaranteeLetterDefinitions: "Гарантийные письма",
		publicOfferDefinitions: "Оферты",
		metricsByFeedbacks: "По отзывам",
		metricsByGuaranteeLetter: "По гарантийным письмам",
		metricsByPublicOffer: "По акцептам оферта",
		unavailability: "Периоды недоступности",
		general: "Сведения",
		account: "Аккаунт",
		profile: "Профиль",
		profiles: "Профили",
		trusts: "Доверенности",
		settings: "Настройки уведомлений",
		notifications: "Уведомления",
		employees: "Сотрудники",
		masterAccount: "Мастер-аккаунт",
		head: "Руководитель",
		organization: "Сведения об организации",
		employee: "Сведения о сотруднике",
		changeEmail: "Изменение адреса электронной почты",
		changePassword: "Изменение пароля",
		fieldFilter: "Фильтр по полю",
		setValue: "Установить значение",
		project: "Проект",
		mainInfo: "Основные сведения",
		additionalInfo: "Дополнительные сведения",
		document: "Документ",
		changeHistory: "История изменения",
		changeDocumentRequest: "Заявка по документу",
		bankDetails: "Банковские реквизиты",
		documents: "Документы",
		history: "История",
		comments: "Комментарии",
		services: "Услуги",
		agreements: "Договоры",
		prepayments: "Авансовые платежи",
		invoices: "Выставленные счета",
		ports: "Порты",
		departments: "Управления",
		metricsByTime: "По времени",
		metricsByCost: "По стоимости",
		metricsByProperty: "По объекту имущества",
		metricsByCounterparty: "По контрагентам",
		metricsByAgreements: "По договорам",
		tariffGeneral: "Сведения о тарифе",
		tariffs: "Тарифы",
		tariffAlgorithms: "Алгоритмы тарификации",
		tariffRates: "Тарифные ставки",
		destinations: "Места начала и окончания операций",
		applications: "Заявки",
		integrations: "Интеграции",
		boats: "Суда",
		shipowners: "Судовладельцы",
		tugboats: "Буксиры",
		icebreakers: "Ледоколы",
		environmentalVessels: "Суда экологического назначения",
		hydrographicBoats: "Гидрографические катера",
		flags: "Флаги",
		boatTypes: "Типы судов",
		piers: "Причалы",
		crewboats: "Разъездные суда",
		floatingCranes: "Плавкраны",
		roles: "Роли",
		permissions: "Права доступа",
		templates: "Письма",
		letterEditor: "Редактор писем",
		recipientRule: "Правило получателей письма",
		contacts: "Контакты служб",
		counterpartyEnterpriseBranches: "Филиалы ФГУП «Росморпорт»",
		counterpartyBranches: "Филиалы",
		serviceDefinitions: "Услуги",
		transitions: "Статусы и переходы",
		agreementDefinitions: "Договоры",
		agreementDefinitionDocumentTemplate: "Шаблон документа договора",
		publicOfferDefinitionDocumentTemplate: "Шаблон документа публичной оферты",
		invoiceTemplate: "Шаблон счета",
		additionalServices: "Дополнительные услуги",
		confirmationDocument: "Подтверждающий документ"
	},
	titles: {
		versions: "Версии",
		publicOfferNumber: "Публичная оферта {version}",
		publicOffer: "Публичная оферта",
		publicOfferValidityPeriod: "Срок действия публичной оферты",
		guaranteeLetterDefinition: "Гарантийное письмо",
		guaranteeLetterDefinitionCreate: "Новое гарантийное письмо",
		departmentList: "Список управлений {branchName}",
		selectRoles: "Выбрать роли",
		publicOfferDefinitionCreate: "Новая публичная оферта",
		fastChoice: "Быстрый выбор",
		notifications: "Уведомления",
		workTime: "Время работы",
		dispatcherContacts: "Контакты диспетчерской",
		edit: "Редактирование",
		branch: {
			kpp: "КПП {kpp}",
			createdAt: "Дата добавления {createdAt}"
		},
		branchGeneral: "Сведения филиала",
		serviceDefinitionCreate: "Новые услуги",
		additionalServiceCreate: "Новые дополнительные услуги",
		documentFile: "Файл документа",
		permissions: "Разрешения",
		unavailabilityCreate: "Новый период недоступности",
		workTimeEdit: "Изменение рабочего времени",
		workTimeCreate: "Новое рабочее время",
		contactCreate: "Новый контакт",
		metricsByTime: "Статистика по времени",
		metricsByCost: "Статистика по стоимости",
		metricsByProperty: "Статистика по объекту имущества",
		metricsByCounterparty: "Статистика по контрагентам",
		metricsByAgreements: "Статистика по договорам",
		roleCreate: "Новая роль",
		employeeCreate: "Новый сотрудник",
		headOffice: "Центральный аппарат",
		ports: "Порты",
		portCreate: "Новый порт",
		departments: "Управления",
		branches: "Филиалы",
		branchCreate: "Новый филиал",
		departmentCreate: "Новое управление",
		invoiceTemplateCreate: "Добавление нового шаблона счета",
		tariffCreate: "Новый тариф",
		agreements: "Договоры",
		agreement: "Договор",
		ownAgreements: "Мои договоры",
		newAgreement: "Новый договор",
		general: "Сведения",
		confirmationDocument: "Подтверждающий документ оказания услуг",
		confirmationDocumentEditShort: "Редактирование подтверждающего документа",
		confirmationDocumentEdit: "Редактирование подтверждающего документа оказания услуг",
		trust: "Доверенность",
		trusts: "Доверенности",
		profile: "Профиль",
		profiles: "Профили",
		roles: "Роли",
		applications: "Список заявок",
		counterparties: "Контрагенты",
		counterpartyCreate: "Новый контрагент",
		users: "Пользователи",
		characteristics: "Признаки",
		fns: "Контур.Фокус",
		createEmployee: "Новый сотрудник",
		createTrust: "Добавление доверенности",
		employee: "Сотрудник",
		employees: "Сотрудники",
		masterAccount: "Мастер-аккаунт",
		offices: "Предприятия",
		head: "Руководитель",
		inviteAnEmployee: "Приглашение сотрудника",
		inviteToJoinAnOrganization: "Запрос на прикрепление к организации",
		invitesToJoinAnOrganization: "Запросы на присоединение к организации",
		requestForAccessToMasterAccount: "Запрос на получение доступа к мастер-аккаунту",
		requestsForAccessToMasterAccount: "Запросы на получение доступа к мастер-аккаунту",
		appealToDigitalSignature: "Обращение к электронной подписи",
		chooseDigitalSignature: "Выберите электронную подпись",
		loanAgreement: "Договор займа",
		loanAgreements: "Договоры займа",
		payments: "Фактическое движение денежных средств",
		overdues: "Просроченная задолженность",
		tranches: "Траншевое финансирование",
		loanSchedule: "График возврата займа",
		rmp: "ФГУП «Росморпорт»",
		rmpOrganization: "ФГУП «Росморпорт» - Личный кабинет Администратора",
		rmpMasterAccount: "ФГУП «Росморпорт» - Личный кабинет Мастер-аккаунта",
		rmpCounterparty: "ФГУП «Росморпорт» - Личный кабинет Контрагента",
		rmpEnterprise: "ФГУП «Росморпорт» - Личный кабинет Предприятия ФГУП",
		rmpId: "ФГУП «Росморпорт» - Вход в личный кабинет",
		signatureGeneral: "Сведения об электронной подписи",
		certificateGeneral: "Сведения о сертификате",
		documentEditing: "Редактирование документа",
		interestByPeriod: "Проценты за период",
		overdueInterest: "Просроченная задолженность по процентам",
		penaltyInterest: "Реестр начисленных штрафов/пеней",
		accruedInterest: "Реестр начисленных процентов",
		treasuryStatementRecords: "Платежные поручения",
		treasuryStatementPayments: "Платежи",
		securityAgreements: "Обеспечение",
		productionStatus: "Статус производства в разрезе должников",
		debtorRequirements: "Реестр требований",
		attachDocumentsList: "Приложите перечень документов",
		selectBranch: "Шаг 3. Выберите филиал",
		enterContactInformation: "Шаг 2. Укажите контактную информацию",
		enterInnYourOrganization: "Шаг 1. Укажите ИНН организации",
		masterAccountAccessApplication: {
			legalEntityCounterpartyType: "Шаг 4. Подтвердите сведения об организации",
			legalPersonCounterpartyType: "Подтвердите сведения об индивидуальном предпринимателе"
		},
		publicDocuments: "База общедоступных документов",
		createNewDocumentRequest: "Заявка на создание нового документа",
		document: "Карточка документа",
		newDocument: "Новый документ",
		requestAccepting: "Согласование заявки",
		createUpdateDocumentRequest: "Заявка на изменение",
		createUnpublishDocumentRequest: "Заявка на снятие с публикации",
		requests: "Реестр заявок на изменение документов",
		auth: "Авторизация",
		confirmPhone: "Подтверждение номера телефона",
		confirmPhoneSuccess: "Номер успешно подтвержден!",
		confirmEmail: "Подтверждение адреса электронной почты",
		confirmEmailSuccess: "Адрес успешно подтвержден!",
		forgotPassword: "Восстановить доступ",
		resetPassword: "Установка нового пароля",
		resetPasswordSuccess: "Пароль успешно изменён!",
		selectProfile: "Выбор профиля",
		myDocuments: "Мои документы",
		welcome: "Добро пожаловать!",
		bankAccounts: "Счета",
		bankAccountCreate: "Новый счет",
		bankAccount: "Просмотр счета",
		tugBoats: "Буксиры",
		icebreakers: "Ледоколы",
		environmentalVessels: "Суда экологического назначения",
		hydrographicBoats: "Гидрографические катера",
		tugboatCreate: "Новое судно",
		icebreakerCreate: "Новый ледокол",
		environmentalVesselCreate: "Новое судно экологического назначения",
		hydrographicBoatCreate: "Новый гидрографический катер",
		crewboats: "Разъездные суда",
		crewboatCreate: "Новое разъездное судно",
		floatingCranes: "Плавкраны",
		floatingCraneCreate: "Новый плавкран",
		piers: "Причалы",
		pierCreate: "Новый причал",
		ownBoatApplications: "Мой флот",
		boatApplications: "Справочник судов от контрагентов",
		boatCreate: "Новое судно",
		shipownerCreate: "Новый судовладелец",
		flagCreate: "Новый флаг",
		boatTypeCreate: "Новый тип судов",
		advancedSearch: "Расширенный поиск",
		servicesAgreement: "Договор на услуги",
		newServices: "Новые услуги",
		tugBoatSelection: "Выбор буксира",
		crewBoatSelection: "Выбор разъездных судов",
		floatingCraneSelection: "Выбор плавкранов",
		pierSelection: "Выбор причалов",
		propertySelection: "Выбор объектов имущества",
		metrics: "Статистика",
		tariffs: "Тарифы",
		portDestinationCreate: "Новое место начала и окончания операции",
		tariffRateCreate: "Новая тарифная ставка",
		tariffRate: "Тарифная ставка",
		boats: "Справочник судов",
		shipowners: "Судовладельцы",
		flags: "Флаги",
		boatTypes: "Типы судов",
		location: "Координаты",
		templates: "Письма",
		agreementDefinitionCreate: "Новый договор",
		browserNotifications: "Уведомления в браузере",
		settings: "Настройки"
	},
	metaTitles: {
		loan: "Кабинет заемщика",
		loanSchedule: "График платежей",
		accruedInterest: "Реестр начисленных процентов",
		overdueInterest: "Просроченные проценты и пени",
		agreementsAccruedInterest: "Начисление процентов",
		cashFlow: "Реестр ДДС",
		treasuryStatement: "Загрузка выписки УФК",
		troubledBorrower: "Паспорт проблемного заемщика",
		troubledBorrowers: "Реестр проблемных заемщиков",
		bodDocuments: "База общедоступных документов",
		createNewDocumentRequest: "Заявка на создание нового документа",
		document: "Карточка документа"
	},
	content: {
		noNotifications: "Нет уведомлений",
		permissions: "Права доступа",
		noPermissionsAvailable: "Нет доступных прав доступа",
		portalActivity: "Активность по порталу",
		requiresAction: "Требуют действий",
		activeAgreements: "Активные договоры",
		processingAgreements: "Договоры в обработке",
		processingServices: "Услуги в обработке",
		viewAll: "Смотреть все",
		metricsServicesAvgTime: "Среднее время обработки услуг за период",
		metricsCounterpartiesCreated: "Новых контрагентов за период",
		metricsCounterpartiesActive: "Активных контрагентов за период",
		metricsServicesTotalAmount: "Общая стоимость услуг за период",
		metricsAgreementsActivated: "Активировано договоров за период",
		servicesInitiated: "Услуг на исполнении",
		servicesInReview: "Услуг на рассмотрении",
		servicesCompleted: "Выполнено услуг за период",
		servicesDeclined: "Услуг отклонено",
		metricsForPeriod: "Статистика за",
		frequentlyUsedServices: "Часто заказываемые услуги",
		noDocuments: "Документы отсутствуют",
		noData: "Отсутствуют сведения",
		noShips: "Нет судов по вашим параметрам",
		shipNotFound: "Нет необходимого судна в результатах поиска?",
		useAdvancedSearch: "Воспользуйтесь расширенным поиском",
		noFeedback: "Отзыв отсутствует",
		kopecks: "коп",
		rubles: "руб",
		noEmployees: "Нет сотрудников",
		noOffices: "Нет предприятий",
		noProfiles: "Нет профилей",
		noTariffs: "Нет тарифов",
		noPrepayments: "Нет авансовых платежей",
		noInvoices: "Нет выставленных счетов",
		noCounterparties: "Нет контрагентов",
		noMasterAccountAccessApplications: "Нет заявок на доступ к мастер-аккаунту",
		noPorts: "Нет портов",
		noBranches: "Нет филиалов",
		branchesEmpty: {
			title: "Филиалы организации",
			description: "Укажите обособленные подразделения, входящие в структуру организации. Для каждого филиала заполните наименование, КПП, адрес и банковские реквизиты.",
			hint: "Если у организации нет филиалов, оставьте раздел незаполненным."
		},
		noDepartments: "Нет управлений",
		noBoatApplications: "Нет судов",
		noApplications: "Нет заявок",
		boatsListEmpty: "Нет судов",
		shipownersListEmpty: "Нет судовладельцев",
		flagsListEmpty: "Нет флагов",
		boatTypesListEmpty: "Нет типов судов",
		noFloatingCranes: "Нет плавкранов",
		noCrewboats: "Нет разъездных судов",
		noPiers: "Нет причалов",
		noTugboats: "Нет буксиров",
		noIcebreakers: "Нет ледоколов",
		noOwnDocuments: "Документы отсутствуют",
		noAgreements: "Нет договоров",
		filter: "Фильтры",
		chooseType: "Выберите тип",
		enterGeneral: "Укажите сведения",
		lastUpdateTime: "Время последнего обновления:",
		generalNotUpdated: "сведения не обновлялись",
		availableAfterSaving: "Доступно после сохранения",
		expireAt: "Доверенность до",
		owner: "Владелец",
		verificationCenter: "Удостоверяющий центр",
		from: "от",
		documentVersion: "Версия документа",
		titleDocument: "Документ основания",
		reasonForScheduleChange: "Причина изменения графика",
		comment: "Комментарий",
		withoutComments: "Без комментариев",
		noNotes: "Нет записей",
		total: "Итого",
		allInAll: "Всего",
		remainingDebt: "Остаток задолженности",
		loanScheduleVersionsNotFound: "Не найдено версий графика возврата займа",
		youCanDownloadTrustTemplateInWordFormat: "Вы можете скачать шаблон доверенности в формате word",
		isProblem: "Является проблемой",
		agreementNumber: "Номер договора",
		noDebtors: "У вас нет должников",
		noBoats: "У вас нет судов",
		noTrusts: "У вас нет доверенностей",
		noBankAccounts: "Нет счетов",
		chooseModuleToContinue: "Выберите модуль для продолжения",
		agreements: "Договоры",
		selectedTugBoatsCount: "Выбрано буксиров",
		selectedCrewBoatsCount: "Выбрано разъездных судов",
		selectedFloatingCranesCount: "Выбрано плавкранов",
		selectedPiersCount: "Выбрано причалов",
		selectedIcebreakersCount: "Выбрано ледоколов",
		selectedPropertiesCount: "Выбрано объектов имущества",
		selectedIcebreaker: "Выбран ледокол",
		tugBoat: "Буксир",
		crewboat: "Разъездное судно",
		icebreaker: "Ледокол",
		pier: "Причал",
		floatingCrane: "Плавкран",
		vat: "НДС",
		withoutVat: "Без НДС",
		withoutVatLowercase: "без НДС",
		noServices: "Заявки на оказание услуг отсутствуют",
		noOwnAgreements: "Заявки на заключение договоров отсутствуют",
		uploadServiceDocumentText: "Вы можете подписать сформированный документ или обновить текущий через загрузку файла.",
		agreementPaymentInvoice: "Cчет на оплату договора",
		noPortDestinations: "Нет мест начала и окончания операций",
		frequentServices: {
			noData: "Пока здесь пусто — начните пользоваться услугами, и они отобразятся в этом разделе для быстрого доступа."
		},
		actionsRequiredAgreementAndService: {
			noData: "В настоящее время действий по вашим услугам и договорам не требуется."
		},
		activeAgreementsEmpty: {
			part1: "Для заключения нового договора перейдите в ",
			part2: "раздел"
		},
		userNewEmpty: {
			newAgreementCreationLink: {
				part1: "Чтобы создать заявку на оказание услуг, необходимо {link}.",
				part2: "заключить договор"
			},
			newUserInstructionsLink: {
				part1: "Для работы на портале предусмотрена соответствующая инструкция, с которой можно ознакомиться",
				part2: "здесь"
			}
		},
		servicesInProgressEmpty: "Нет услуг в обработке",
		agreementsInProgressEmpty: "Нет договоров в обработке",
		portalActivityEmpty: "Нет недавней активности",
		noRoles: "Нет ролей"
	},
	validation: {
		bankAccountNumber: "Неверный номер счета",
		correspondentAccount: "Неверный корреспондентский счет",
		bankIdentificationCode: "Неверный БИК",
		inn: "Неверный ИНН",
		snils: "Неверный СНИЛС",
		ogrn: "Неверный ОГРН",
		ogrnip: "Неверный ОГРНИП",
		kpp: "Неверный КПП",
		validPassword: "Неверный пароль",
		validOnlyLatin: "Только латинские буквы",
		validOnlyUppercaseLatinAndDigits: "Только заглавные латинские буквы и цифры",
		validPhone: "Неверный формат телефона",
		required: "Поле не может быть пустым",
		maxNumber: "Не более {number}",
		maxNumberWithField: "Не более {number}. Значение не может быть больше, чем {field}",
		minNumber: "Не менее {number}",
		greaterThan: "Значение должно быть больше {number}",
		lessThan: "Значение должно быть меньше {number}",
		lessThanField: "Значение должно быть меньше {number} ({field})",
		maxDate: "Не позднее {number}",
		minDate: "Не раньше {number}",
		validOnlyNumbers: "Неверный формат числа",
		twoDecimalPlaces: "Допускается не более двух знаков после запятой",
		validOnlyIntegerNumbers: "Поле принимает только целые числа",
		validOnlyMultipleOfHalfNumbers: "Поле принимает только числа, кратные 0.5",
		validIpAddress: "Неверный формат адреса",
		invalidDate: "Неверная дата",
		validLastname: "Неверный формат фамилии",
		validFirstname: "Неверный формат имени",
		validMiddleName: "Неверный формат отчества",
		validEmail: "Неверный формат адреса электронной почты",
		validTime: "Неверный формат времени",
		notZeroTime: "Не может быть равно 00:00",
		maxTimeSpan: "Значение не должно превышать продолжительность оказания услуг",
		validConfirmedEmail: "Адреса электронной почты не совпадают",
		emailAlreadyUsedInAccount: "Указанный адрес уже используется в учётной записи",
		accountWithThisEmailIsExist: "Аккаунт с таким адресом электронной почты уже существует",
		maxLength: "Максимальное количество символов: {number}",
		minLength: "Минимальное количество символов: {number}",
		year: "Неверный год",
		imo: "Неверный формат IMO",
		mmsi: "Неверный формат MMSI",
		calculationObjectCode: "Неверный формат КО",
		validOnlyCurrency: "Неверный формат суммы",
		passwordMinSymbols: "Нет символов | Не менее {n} символа | Не менее {n} символов",
		passwordMaxSymbols: "Нет символов | Не более {n} символа | Не более {n} символов",
		passwordMinUppercaseSymbols: "Нет букв | Не менее {n} заглавной буквы | Не менее {n} заглавных букв",
		passwordMinLowercaseSymbols: "Нет букв | Не менее {n} строчной буквы | Не менее {n} строчных букв",
		passwordNoSpaces: "Пароль не должен содержать пробелов",
		passwordMinDigits: "Нет цифр | Не менее {n} цифры | Не менее {n} цифр",
		passwordMinSpecialSymbols: "Нет специальных символов | Не менее {n} специального символа | Не менее {n} специальных символов",
		passwordMinUniqChars: "Минимальное число уникальных символов в пароле - {num}",
		coordinates: {
			format: "Координаты должны быть в формате: широта, долгота",
			longitudeRange: "Долгота должна быть от -180 до 180",
			latitudeRange: "Широта должна быть от -90 до 90"
		},
		maxDecimalPlaces: "Только целые числа | Не более {n} знака после запятой | Не более {n} знаков после запятой"
	},
	tables: {
		version: "Версия",
		validFrom: "Дата начала действия",
		validTo: "Дата окончания действия",
		isPublished: "Опубликована",
		acceptedAt: "Дата принятия",
		limitAmount: "Максимальная стоимость",
		hours: "Расписание",
		from: "Дата начала",
		till: "Дата окончания",
		reason: "Причина",
		validToFormatted: "Дата окончания",
		validFromFormatted: "Дата начала",
		divisionName: "Подразделение",
		note: "Примечание",
		id: "Действие",
		startTime: "Время начала",
		endTime: "Время окончания",
		dayOfWeek: "День недели",
		workHours: "Расписание",
		isPublic: "Публичный",
		value: "Значение",
		contactPointTitle: "Наименование службы",
		relatedTo: "Относится к",
		loading: "Загрузка сведений...",
		createdAt: "Дата добавления",
		uploadedAt: "Дата загрузки",
		expireAt: "Действительно до",
		ogrn: "ОГРН",
		inn: "ИНН",
		kpp: "КПП",
		type: "Тип",
		counterpartyType: "Тип",
		phone: "Номер телефона",
		ports: "Порты",
		status: "Статус",
		fullName: "ФИО",
		heads: "ФИО руководителя",
		title: "Наименование",
		shortName: "Наименование",
		login: "Логин",
		password: "Пароль",
		email: "Адрес электронной почты",
		position: "Должность",
		number: "Номер",
		acceptDate: "Дата акцептования",
		isSigned: "Электронная подпись",
		roles: "Роли",
		description: "Описание",
		date: "Дата",
		dateFact: "Дата (факт)",
		quarter: "Квартал",
		amountRUB: "Сумма, ₽",
		isProblem: "Является проблемной",
		comment: "Комментарий",
		isRequired: "Обязательные услуги",
		plannedRepaymentAmount: "Плановая сумма погашения",
		issuanceLoanRUB: "Выдача займа, ₽",
		actualRepaymentAmountRUB: "Фактическая сумма погашения, ₽",
		withdrawalForDelay: "Вынос на просрочку",
		paymentOfDelay: "Уплата просрочки",
		consider: "Учитывать",
		borrower: "Заемщик",
		agreement: "Договор",
		currentStatus: "Текущий статус",
		daysByPeriod: "Дней за период",
		accruedAmount: "Начислено (сумма), ₽",
		accountedAmount: "Передано в бухгалтерию, ₽",
		accountedDate: "Дата педачи в бухгалтерию",
		accrualType: "Тип начисления",
		accrualDate: "Дата начисления",
		paymentDate: "Дата оплаты",
		plannedPaymentDate: "Дата платежа",
		accruedAmountSum: "Сумма процентов",
		numberPaymentOrder: "№п/п",
		paymentExpense: "Статья ДДС",
		isForcedPayment: "Принудительное взыскание",
		paymentDescription: "Назначение платежа",
		trust: "Доверенность",
		pledges: "Залоги",
		securityKindAndLocation: "Вид обеспечения [местонахождения: субъект РФ]",
		guarantor: "Обеспечитель",
		agreementValue: "Стоимость по договору, млн. руб.",
		lastAssessmentDateAndType: "Дата последней оценки [тип проведенной оценки]",
		lastValuation: "Стоимость по последней оценке, млн. руб.",
		event: "Мероприятие",
		controlDate: "Контрольная дата",
		factualDate: "Фактическая дата",
		organizationShortName: "Сокращенное наименование организации",
		loanAgreements: "Договоры займа",
		frpSum: "Сумма ДЗ, млн. руб.",
		requirements: "Требования",
		fullRefundStatus: "Полный возврат",
		responsibleUser: "Ответственный",
		newTroubledBorrowerPassportGeneration: "Генерация",
		decliner: "Отклонил",
		documentSection: "Раздел",
		financingScheme: "Программа",
		documentTitle: "Наименование документа",
		responsibleDepartment: "Ответственное подразделение ФРП",
		documentOnDisk: "Документ на диске",
		share: "Поделиться",
		createdDate: "Дата создания",
		initiator: "Инициатор",
		requestType: "Тип заявки",
		changeWarrant: "Основание для изменения",
		changeDescription: "Суть изменения",
		documentName: "Наименование",
		documentType: "Вид документа",
		fileName: "Наименование файла",
		creationDate: "Дата добавления",
		expirationDate: "Действителен до",
		bankAccountNumber: "Номер счета",
		bankIdentificationCode: "БИК",
		bankName: "Наименование банка",
		correspondentAccount: "Корреспондентский счет",
		name: "Наименование",
		shipType: "Тип судна",
		power: "Мощность, (кВт)",
		yearOfBuilding: "Год постройки",
		portOfRegistry: "Порт регистрации",
		port: "Порт",
		department: "Управление",
		flag: "Флаг",
		shipowner: "Судовладелец",
		action: "Действие",
		isArchived: "Статус",
		managementDepartments: "Управление",
		serviceNumber: "№ услуг",
		serviceType: "Тип услуг",
		counterpartyTitle: "Организация",
		division: "Подразделение",
		workflowState: "Статус",
		applicationDate: "Дата подачи заявки",
		employee: "Сотрудник",
		address: "Адрес",
		location: "Координаты",
		unit: "Единица измерения",
		algorithm: "Алгоритм",
		cost: "Стоимость",
		unitPrice: "Цена за единицу измерения",
		currentActiveTariffRateUnitPrice: "Текущая ставка",
		vat: "НДС",
		propertyName: "Объект имущества",
		portDestinations: {
			shortName: "Краткое наименование",
			fullName: "Наименование"
		},
		englishName: "Английское наименование",
		imo: "Номер IMO",
		numberOfRegistry: "Регистровый номер",
		callSign: "Позывной",
		counterparty: "Контрагент",
		countryNameRu: "Наименование страны",
		countryNameEn: "Наименование страны (латиницей)",
		countryCode: "Код страны",
		prepaymentDate: "Дата и время совершения аванса",
		prepaymentNumber: "Номер аванса",
		prepaymentAmount: "Сумма аванса",
		invoiceDate: "Дата и время выставления счёта",
		invoiceNumber: "Номер счёта",
		invoiceAmount: "Сумма счёта",
		boatOwnershipType: "Вид владения судном",
		code: "Код",
		branch: "Филиал",
		transitionName: "Наименование перехода",
		transitionFromStatus: "Статус до перехода",
		transitionToStatus: "Статус после перехода",
		transitionRoles: "Роли, осуществляющие переход",
		notificationRecipientRoles: "Роли, получающие уведомление",
		transitionExecuterType: "Ответственный",
		recipientType: "Тип получателя",
		isOverridden: "Переопределён",
		resource: "Ресурс",
		nomenclatureCode: "Код номенклатуры",
		activityType: "Вид деятельности"
	},
	specialDetails: {
		drinkingWaterBunkering: {
			drinkingWaterBunkeringInitialMeterReadingCubicMeters: "Начальные показания счетчика, м³",
			drinkingWaterBunkeringFinalMeterReadingCubicMeters: "Конечные показания счетчика, м³",
			drinkingWaterBunkeringSupplyPointNumber: "Номер колонки",
			drinkingWaterBunkeringMeterNumber: "Номер счетчика"
		},
		serviceProvisionSpecialist: {
			serviceProvisionSpecialistName: "ФИО специалиста, оказавшего услуги"
		},
		legalEntityCounterparty: {
			longName: "Полное наименование",
			registrationDate: "Дата регистрации организации",
			legalAddress: "Юридический адрес",
			ogrn: "ОГРН",
			shortName: "Краткое наименование",
			opf: "Наименование ОПФ",
			inn: "ИНН",
			kpp: "КПП",
			requestorEmail: "Контактный адрес электронной почты",
			createdAt: "Дата добавления",
			email: "Адрес электронной почты",
			phone: "Номер телефона",
			description: "Комментарий"
		},
		legalPersonCounterparty: {
			fullName: "ФИО",
			ogrnIp: "ОГРНИП",
			registrationDate: "Дата регистрации",
			inn: "ИНН",
			ogrn: "ОГРН",
			createdAt: "Дата добавления",
			requestorEmail: "Контактный адрес электронной почты",
			email: "Адрес электронной почты",
			phone: "Номер телефона",
			description: "Комментарий"
		},
		counterpartyHead: {
			fullName: "ФИО",
			lastName: "Фамилия",
			firstName: "Имя",
			middleName: "Отчество",
			position: "Должность",
			inn: "ИНН",
			snils: "СНИЛС",
			description: "Комментарий"
		},
		masterAccountApplicationAccessReviewer: {
			name: "ФИО",
			position: "Должность",
			reviewComment: "Причина отклонения"
		},
		pierGeneral: {
			name: "Наименование",
			length: "Длина причальной стенки, предназначенная для стоянки судов (м.)",
			depth: "Глубина у причальной стенки (м.)",
			servicePorts: "Порты оказания услуг",
			status: "Текущий статус",
			calculationObjectCode: "Калькуляционный объект (КО)"
		},
		counterpartyEmployee: {
			inn: "ИНН",
			email: "Адрес электронной почты",
			phone: "Номер телефона",
			position: "Должность",
			snils: "СНИЛС",
			firstName: "Имя",
			middleName: "Отчество",
			lastName: "Фамилия"
		},
		employeeSettings: {
			notificationsEnabled: "Получать уведомления об изменении статусов заявок",
			notificationApplicationsScope: "По каким заявкам уведомлять",
			notificationChangesScope: "Уведомления по изменениям"
		},
		trust: {
			file: "Доверенность",
			certificateInfo: "Электронная подпись",
			expireDate: "Действителен до",
			acceptedDate: "Дата и время акцептования",
			actionerFullName: "Кем акцептована"
		},
		edo: {
			operator: "Оператор ЭДО",
			integration: "Интеграция с ЭДО",
			fnsParticipantId: "Идентификатор ЭДО",
			boxId: "Идентификатор ящика",
			lastVerifiedAt: "Последняя успешная проверка"
		},
		shipownerGeneral: {
			name: "Имя судовладельца",
			imo: "IMO",
			boatOwnershipType: "Вид владения судном",
			createdAt: "Дата добавления"
		},
		flagGeneral: {
			countryNameRu: "Наименование страны",
			countryNameEn: "Наименование страны (латиницей)",
			countryCode: "Код страны"
		},
		boatTypeGeneral: {
			description: "Описание",
			code: "Код",
			counterpartyBoatTypeNumber: "Номер"
		},
		boatGeneral: {
			name: "Наименование",
			translitName: "Наименование судна (транслит)",
			portOfRegistry: "Порт регистрации",
			grt: "GRT (т.)",
			callSign: "Позывной",
			kind: "Тип судна",
			length: "Длина (м.)",
			flag: "Флаг",
			mmsi: "Номер MMSI",
			power: "Мощность ГД (кВт.)",
			boatPower: "Мощность ГД (кВт.)",
			numberOfRegistry: "Регистровый номер",
			width: "Ширина (м.)",
			boatWidth: "Ширина (м.)",
			imo: "Номер IMO",
			height: "Высота борта (м.)",
			deadWeight: "Дедвейт (т.)",
			boatDeadWeight: "Дедвейт (т.)",
			status: "Текущий статус",
			exclusionGRT: "Исключение из GRT рег (т.)",
			yearOfBuilding: "Год постройки",
			precipitationMaxValue: "Максимальная осадка (м.)",
			calculatedGRT: "Расчетное значение GRT (т.)",
			type: "Тип судна",
			boatType: "Тип",
			shipowner: "Судовладелец",
			bowThruster: "Подруливающие устройство",
			hasBowThruster: "Имеет подруливающие устройство",
			registerClass: "Класс регистра",
			division: "Подразделение",
			servicePorts: "Порты оказания услуг",
			calculationObjectCode: "Калькуляционный объект (КО)"
		},
		titles: {
			drinkingWaterBunkering: "Параметры бункеровки питьевой водой",
			serviceProvisionSpecialist: "Специалист, оказавший услуги",
			counterparty: "Контрагент",
			approvalOrder: "Приказ",
			additionalDivisions: "Доступные подразделения",
			divisionVisibility: "Область видимости",
			location: "Локация",
			serviceParameters: "Параметры оказания услуг",
			mainCounterpartyGeneral: "Сведения головной организации",
			general: "Сведения",
			contacts: "Контактная информация",
			unavailability: "Период недоступности",
			bankCredentials: "Реквизиты",
			pierGeneral: "Основные сведения о причале",
			counterpartyEmployee: "Сведения",
			edo: "Реквизиты ЭДО",
			legalBasisKind: "Правовое основание",
			boatGeneral: "Судно",
			boatBasicInfo: "Основные сведения",
			boatDimensions: "Габаритные размеры",
			boatTonnage: "Тоннаж и вместимость",
			boatRegistration: "Регистрация и принадлежность",
			boatTechnical: "Технические характеристики",
			trust: "Доверенность",
			axapta: "Axapta",
			harborDues: "Harbor Dues",
			portDestination: "Основные сведения",
			balanceInformation: "Сведения о балансе",
			customer: "Контрагент",
			customerAgreement: "Контрагент и договор",
			shipownerGeneral: "Сведения о судовладельце",
			flagGeneral: "Сведения о флаге",
			boatTypeGeneral: "Сведения о типе судов",
			tariffGeneral: "Сведения о тарифе",
			tariffRate: "Тарифная ставка",
			tariffRateApprovalOrder: "Сведения о приказе",
			serviceDetails: "Сведения об услугах",
			providedServices: "Оказываемые услуги",
			division: "Управление",
			contact: "Основные сведения о контакте",
			rejectDetails: "Сведения об отклонении",
			operationalData: "Оперативные сведения",
			legalPersonCounterparty: "Сведения об индивидуальном предпринимателе",
			legalEntityCounterparty: "Сведения об организации",
			counterpartyHead: "Сведения о руководителях",
			cancelReason: "Причина отмены",
			rejectReason: "Причина отклонения",
			bankAccount: "Сведения",
			department: "Основные сведения",
			port: "Основные сведения",
			employee: "Основные сведения",
			legalEntityGeneralHead: "Руководитель",
			role: "Сведения",
			additionalService: "Сведения",
			head: "Основные сведения",
			notificationTemplate: "Основные сведения",
			recipientRule: "Основные сведения",
			agreement: "Договор",
			publicOffer: "Публичная оферта"
		},
		floatingCranes: {
			name: "Плавкран"
		},
		division: {
			division: "Подразделение",
			port: "Порт"
		},
		providedServices: {
			serviceType: "Тип услуг"
		},
		serviceDetails: {
			services: "Услуги",
			division: "Подразделение",
			legalBasisKind: "Правовое основание",
			port: "Порт"
		},
		bankAccount: {
			accountNumber: "Номер счета",
			bankName: "Наименование банка",
			bic: "БИК",
			correspondingAccount: "Корреспондентский счет"
		},
		timePlace: {
			title: {
				default: "Время и место",
				[ApiServiceType.PierService]: "Дата и время",
				[ApiServiceType.InformationService]: "Дата"
			},
			startDestinationShortName: "Место начала",
			endDestinationShortName: "Место окончания",
			startDate: "Дата начала использования",
			startTime: "Время начала использования",
			startDateTime: "Дата и время начала",
			endDate: "Дата окончания использования",
			endTime: "Время окончания использования",
			endDateTime: "Дата и время окончания"
		},
		timePlacePort: {
			startDate: "Дата начала",
			startDateTime: "Дата и время начала",
			endDate: "Дата окончания",
			endDateTime: "Дата и время окончания",
			startDestinationShortName: "Место начала",
			endDestinationShortName: "Место окончания",
			division: "Подразделение",
			port: "Порт"
		},
		rejectDetails: {
			rejectReason: "Причина отклонения"
		},
		operationalData: {
			agreementNumber: "Номер договора",
			axaptaRegistrationNumber: "Регистрационный номер «Axapta»",
			agreementDate: "Дата договора",
			signingDate: "Дата подписания",
			agreementStartDate: "Дата начала действия договора",
			agreementEndDate: "Дата окончания действия договора",
			serviceTypes: "Доступные услуги"
		},
		balanceInformation: {
			amount: "Баланс",
			amountLimit: "Лимит совокупной стоимости услуг по договору",
			portalProvidedServicesAmount: "Совокупная стоимость услуг, оказанных через Портал",
			remainingPortalLimitAmount: "Остаток лимита совокупной стоимости услуг по данным Портала",
			paymentMethod: "Тип оплаты",
			portDestination: "Основные сведения",
			balanceInformation: "Сведения о балансе",
			customer: "Заказчик"
		},
		axapta: {
			calculationObjectCode: "Калькуляционный объект (КО)"
		},
		harborDues: {
			harborDuesIdentifier: "Идентификатор"
		},
		portDestination: {
			fullName: "Наименование",
			shortName: "Краткое наименование",
			englishName: "Английское наименование"
		},
		customer: {
			shortName: "Краткое наименование",
			fullName: "Наименование",
			ogrnIp: "ОГРНИП",
			inn: "ИНН",
			kpp: "КПП",
			ogrn: "ОГРН",
			legalAddress: "Юридический адрес"
		},
		customerAgreement: {
			shortName: "Краткое наименование",
			fullName: "Наименование",
			ogrnIp: "ОГРНИП",
			inn: "ИНН",
			kpp: "КПП",
			ogrn: "ОГРН",
			legalBasisKind: "Правовое основание"
		},
		tariffGeneral: {
			title: "Наименование",
			unit: "Единица измерения",
			currentActiveTariffRateUnitPrice: "Текущая цена за единицу измерения",
			type: "Тип",
			vat: "НДС",
			port: "Порт",
			serviceType: "Тип услуг",
			algorithm: "Алгоритм",
			division: "Оказывающее подразделение",
			propertyName: "Объект имущества"
		},
		serviceParameters: {
			startDate: "Дата начала оказания услуг",
			endDate: "Дата окончания оказания услуг"
		},
		tariffRate: {
			unitPrice: "Цена за единицу измерения",
			number: "Номер",
			startDate: "Дата начала действия"
		},
		tariffRateApprovalOrder: {
			orderNumber: "Номер приказа",
			approvalDate: "Дата утверждения"
		},
		bankCredentials: {
			accountNumber: "Номер счета",
			bankName: "Наименование банка",
			bic: "БИК",
			correspondingAccount: "Корреспондентский счет",
			correspondentAccount: "Корреспондентский счет",
			bankIdentificationCode: "БИК",
			bankAccountNumber: "Номер счета"
		},
		department: {
			shortName: "Краткое наименование",
			fullName: "Полное наименование",
			actualAddress: "Фактический адрес",
			code: "Код",
			kpp: "КПП",
			parentName: "Филиал"
		},
		port: {
			fullName: "Полное наименование",
			location: "Координаты",
			code: "Код",
			parentName: "Относится к"
		},
		employee: {
			fullName: "Полное наименование",
			inn: "ИНН",
			snils: "СНИЛС",
			email: "Адрес электронной почты",
			phone: "Номер телефона",
			position: "Должность"
		},
		role: {
			name: "Наименование",
			serviceType: "Тип услуг"
		},
		default: {
			timeZone: "Часовой пояс",
			divisionName: "Подразделение",
			serviceProviderDivision: "Оказывающее подразделение",
			divisionScope: "Подразделения",
			amountLimit: "Максимальная стоимость, руб.",
			orderNumber: "Номер приказа",
			approvalDate: "Дата приказа",
			documentTemplate: "Шаблон",
			isPublished: "Опубликован",
			fileId: "Файл оферты",
			"BranchBasin": "Филиалы",
			"Branch": "Филиалы",
			"Department": "Управления",
			"Port": "Порты",
			notificationDefinitionName: "Наименование",
			ports: "Порты",
			dateOfBirth: "Дата рождения",
			bankAccountNumber: "Номер счета",
			bankIdentificationCode: "БИК",
			correspondentAccount: "Корреспондентский счет",
			legalBasisKind: "Правовое основание",
			validFrom: "Дата начала действия",
			validTo: "Дата окончания действия",
			latitude: "Широта, °",
			longitude: "Долгота, °",
			limitAmount: "Максимальная стоимость",
			serviceTypes: "Тип",
			hasAdminAccess: "Доступ в личный кабинет администратора",
			counterpartyName: {
				legalEntity: "Юридическое лицо",
				entrepreneur: "Индивидуальный предприниматель"
			},
			longName: "Полное наименование",
			description: "Комментарий",
			firstName: "Имя",
			middleName: "Отчество",
			lastName: "Фамилия",
			snils: "СНИЛС",
			division: "Подразделение",
			divisions: "Подразделения",
			position: "Должность",
			phone: "Номер телефона",
			email: "Адрес электронной почты",
			status: "Статус",
			reason: "Причина",
			from: "Дата начала",
			till: "Дата окончания",
			comment: "Комментарий",
			shortName: "Краткое наименование",
			fullName: "Полное наименование",
			code: "Код",
			kpp: "КПП",
			inn: "ИНН",
			ogrn: "ОГРН",
			ogrnIp: "ОГРНИП",
			opf: "Организационно-правовая форма",
			actualAddress: "Фактический адрес",
			legalAddress: "Юридический адрес",
			registrationDate: "Дата регистрации",
			roles: "Роли",
			canSignDocuments: "Полномочия",
			name: "Наименование",
			names: "Наименования",
			contactPointTitle: "Наименование службы",
			type: "Тип",
			value: "Значение",
			ext: "Добавочный номер",
			vhfChannels: "Радиоканалы",
			vhfCallsign: "Позывной",
			isPublic: "Публичный",
			formattedWorkHours: "Период действия",
			serviceType: "Тип услуг",
			nomenclatureCode: "Код номенклатуры",
			activityType: "Вид деятельности",
			agreement: "Наименование договора",
			version: "Версия",
			depth: "Глубина у причальной стенки (м.)",
			unavailabilityReason: "Причина недоступности",
			isSignatureRequired: "Необходимо подтверждение с помощью электронной подписи при входе",
			isPhoneConfirmed: "Статус подтверждения телефона"
		},
		head: {},
		notificationTemplate: {
			subjectTemplate: "Тема"
		},
		additionalService: {
			additionalServiceDefinitionName: "Наименование",
			isRequired: "Обязательные услуги"
		}
	},
	details: {
		titles: {
			validFrom: "Дата начала действия",
			validTo: "Дата окончания действия",
			location: "Локация",
			timetableOfWork: "Расписание работы",
			contact: "Контакт",
			contactData: "Контактные данные",
			bankAccount: "Банковские реквизиты",
			agreementKind: "Вид договора",
			tugBoat: "Буксир",
			icebreaker: "Ледокол",
			floatingCrane: "Плавкран",
			crewboat: "Разъездное судно",
			divisionAndPort: "Подразделение и порт",
			ep: {
				general: "Основные сведения об электронной подписи"
			},
			bankName: "Наименование банка",
			paymentMethod: "Тип оплаты",
			amountLimit: "Лимит",
			rejectDetails: "Сведения об отклонении",
			documents: "Документы",
			agreementDuration: "Срок действия",
			additionalDocuments: "Дополнительные документы",
			bankIdentificationCode: "БИК",
			opfName: "Наименование ОПФ",
			correspondentAccount: "Корреспондентский счет",
			bankAccountNumber: "Номер счета",
			counterpartyRegisterDate: "Дата регистрации организации",
			legalPersonRegisterDate: "Дата регистрации ИП",
			registrationDate: "Дата регистрации",
			serviceProvider: "Организация, предоставляющая услуги",
			branch: "Филиал",
			general: "Основные сведения",
			boatGeneral: "Основные сведения о судне",
			shipownerGeneral: "Основные сведения о судовладельце",
			flagGeneral: "Основные сведения о флаге",
			boatTypeGeneral: "Основные сведения о типе судов",
			divisionGeneral: "Основные сведения о подразделении",
			axapta: "Axapta",
			harborDues: "Harbor Dues",
			legalPersonCounterpartyGeneral: "Сведения об ИП",
			counterpartyGeneral: "Сведения об организации",
			counterpartyHeadGeneral: "Сведения о руководителе",
			boatDocuments: "Документы на судно",
			confirmationDocuments: "Подтверждающие документы",
			createdAt: "Дата добавления",
			officeGeneral: "Сведения о Росморпорт",
			employeeGeneral: "Сведения о сотруднике",
			legalEntityGeneral: "Сведения об организации",
			legalEntityHeadGeneral: "Сведения о руководителях",
			legalPersonGeneral: "Сведения об индивидуальном предпринимателе",
			status: "Статус",
			name: "Наименование",
			fullName: "Наименование",
			fullPersonName: "ФИО",
			position: "Должность",
			snils: "СНИЛС",
			ogrn: "ОГРН",
			opf: "Организационно-правовая форма",
			ogrnip: "ОГРНИП",
			kpp: "КПП",
			inn: "ИНН",
			description: "Описание",
			phone: "Номер телефона",
			legalAddress: "Юридический адрес",
			requestorEmail: "Контактный адрес электронной почты",
			email: "Адрес электронной почты",
			commonData: "Общие сведения",
			documentsList: "Перечень документов",
			approvalApplicationResult: "Результат рассмотрения запроса",
			owner: "Владелец",
			issuedBy: "Кем выдан",
			issuedTo: "Кому выдан",
			certificate: "Сертификат",
			expireDate: "Действителен до",
			expire: "Действителен",
			interestPeriod: "Процентный период",
			loanAgreementsCount: "Количество договоров займа",
			totalSum: "Общая сумма",
			interestAccruedAmount: "Доначислено процентов на сумму",
			treasuryStatementRecordsCount: "Всего документов",
			treasuryStatementOrderRecordSum: "Итого поступления",
			treasuryStatementPaymentRecordSum: "Итого выплаты",
			treasuryStatementFinalPaymentsSum: "Итого обработанные",
			treasuryStatementNotFinalPaymentsSum: "Итого необработанные",
			treasuryStatementRecord: "Платежное поручение",
			treasuryStatementRecordDocument: "{number} от {date}",
			counterparty: "Контрагент",
			kbk: "КБК",
			paymentSum: "Сумма",
			paymentPurpose: "Назначение платежа",
			borrower: "Заемщик",
			financingScheme: "Программа",
			loanAgreementsFrpSum: "Сумма ДЗ, млн. руб.",
			loanAgreementsRequirements: "Требования, млн. руб.",
			loanAgreementsMainDebt: "Основной долг",
			loanAgreementsInterest: "Проценты",
			loanAgreementsPenalty: "Неустойка",
			refund: "Возврат средств",
			refundStatus: "Полный возврат",
			partialRefund: "Частичный возврат, в т.ч.",
			refundWithoutAcceptance: "Безакцептно",
			refundBankGuarantee: "Банковская гарантия",
			refundPenalty: "Взыскание",
			remainingRefund: "Остаток к возврату",
			keyDates: "Ключевые даты",
			keyDatesRecall: "Отзыв [ЭС/НС]",
			keyDatesRequirements: "Требования",
			keyDatesDeclaration: "Исковое заявление",
			keyDatesSettlement: "Урегулирование [ЭС/НС]",
			responsibleUsers: "Ответственное подразделение",
			legalDepartmentUser: "ЮД",
			projectManagerUser: "ДП [В случае урегулирования]",
			currentDebtorStatusComment: "Текущий статус процесса взыскания",
			declineReason: "Причина отклонения",
			cancelReason: "Причина отмены",
			applicationDeclineReason: "Причина отклонения запроса",
			acceptor: "Одобрил",
			decliner: "Отклонил",
			canceller: "Отменил изменения",
			file: "Наименование",
			boatName: "Наименование судна",
			IMO: "Номер IMO",
			flag: "Флаг",
			shipowner: "Судовладелец",
			GRT: "GRT (т.)",
			boatLength: "Длина (м.)",
			boatHeight: "Высота борта (м.)",
			portOfRegistry: "Порт регистрации",
			yearOfBuilding: "Год постройки",
			callSign: "Позывной",
			precipitationMaxValue: "Максимальная осадка (м.)",
			MMSI: "Номер MMSI",
			boatType: "Тип судна",
			exclusionGRT: "Исключение из GRT рег (т.)",
			calculatedGRT: "Расчетное значение GRT (т.)",
			boatDeadWeight: "Дедвейт (т.)",
			boatWidth: "Ширина (м.)",
			boatPower: "Мощность ГД (кВт.)",
			numberOfRegistry: "Регистровый номер",
			boatStatus: "Текущий статус",
			operationalData: "Оперативные сведения",
			balanceInformation: "Сведения о балансе",
			customer: "Заказчик",
			customerSigner: "Подписант со стороны заказчика",
			executor: "Исполнитель",
			executorSigner: "Подписант со стороны исполнителя",
			agreementNumber: "Номер договора",
			agreementStartDate: "Дата начала действия договора",
			agreementEndDate: "Дата окончания действия договора",
			agreementSignDate: "Дата заключения договора",
			services: "Услуги",
			balance: "Баланс",
			shortName: "Краткое наименование",
			longName: "Полное наименование",
			trust: "Доверенность",
			lastName: "Фамилия",
			firstName: "Имя",
			middleName: "Отчество",
			terminationReason: "Причина расторжения",
			rejectReason: "Причина отклонения",
			actualAddress: "Фактический адрес",
			type: "Тип",
			agreementSignedDate: "Дата подписания договора",
			agreementExpiredDate: "Срок действия договора, до",
			division: "Подразделение",
			ports: "Порты",
			tugBoatsInfo: "Сведения о буксирах",
			crewboatsInfo: "Сведения о разъездных судах",
			piersInfo: "Сведения о причалах",
			tugBoats: "Буксиры",
			icebreakers: "Ледоколы",
			crewboats: "Разъездные суда",
			pier: "Причал",
			costCalculation: "Расчет стоимости",
			preliminaryCostCalculation: "Предварительный расчет стоимости",
			tariff: "Тариф",
			vat: "НДС",
			preliminaryCostWithVat: "Предварительная стоимость (в том числе НДС)",
			providedServices: "Оказываемые услуги",
			serviceType: "Тип услуг",
			agreement: "Договор",
			publicOffer: "Публичная оферта",
			port: "Порт",
			legalBasisKind: "Правовое основание",
			boat: "Судно",
			counterpartyBoat: "Судно контрагента",
			towingDateLocation: "Время и место буксировки",
			towDate: "Дата подачи буксира",
			towTime: "Время подачи буксира",
			towStartLocation: "Место начала буксировки",
			towEndLocation: "Место окончания буксировки",
			dateTimeLocation: "Дата, время и место",
			cost: "Стоимость",
			hoursCount: "Количество часов",
			servicesGeneral: "Сведения об услугах",
			serviceDescription: "Описание услуг",
			serviceStart: "Начало оказания услуг",
			serviceEnd: "Окончание оказания услуг",
			totalTimeSpent: "Всего затрачено времени",
			initiatorCounterparty: "Клиент",
			servicePrice: "Стоимость услуг",
			boatRepresentative: "Представитель судна",
			pierGeneral: "Основные сведения о причале",
			englishName: "Английское наименование",
			portDestinationGeneral: "Основные сведения о месте начала и окончания операции",
			pierDepth: "Глубина у причальной стенки (м.)",
			pierLength: "Длина причальной стенки, предназначенная для стоянки судов (м.)",
			tariffRate: "Основные сведения о тарифной ставке",
			tariffGeneral: "Основные сведения о тарифе",
			orderGeneral: "Сведения о приказе",
			masterAccountApplicationAccessReviewer: {
				acceptor: "Одобрил",
				decliner: "Отклонил"
			},
			guaranteeLetter: "Гарантийное письмо"
		},
		labels: {
			isRmpSigned: "Подпись со стороны ФГУП «Росморпорт»"
		},
		isSigned: {
			digitallySigned: "Подписано электронной подписью",
			rmpSigned: "Подпись со стороны ФГУП «Росморпорт»",
			counterpartySigned: "Подпись со стороны контрагента",
			directorSigned: "Подпись со стороны директора",
			digitallyMissed: "Электронная подпись отсутствует"
		},
		values: {
			missing: "Отсутствует",
			missingData: "Сведения отсутствуют"
		},
		expireDate: "Действителен до",
		approvedDate: "Дата и время одобрения",
		acceptedDate: "Дата и время акцептования",
		acceptedEmployeeName: "Кем акцептована",
		declinedDate: "Дата и время отклонения",
		declinedEmployeeName: "Кем отклонена",
		canceledDate: "Дата и время отмены",
		declineReason: "Причина отклонения",
		cancelReason: "Причина отмены",
		canceledEmployeeName: "Кем отменена",
		phone: "Телефон",
		phoneConfirmationStatus: "Статус подтверждения телефона",
		isSignatureRequired: "Необходимо подтверждение с помощью электронной подписи при входе",
		startWithDestination: "Начало: {time}, {destination}",
		startWithoutDestination: "Начало: {time}",
		endWithDestination: "Окончание: {time}, {destination}",
		endWithoutDestination: "Окончание: {time}",
		startDestination: "Начало: {destination}",
		endDestination: "Окончание: {destination}",
		created: "Создана: {date}",
		boat: "Судно: {name}"
	},
	status: {
		Active: "Активный",
		Archived: "Архивный",
		Draft: "Черновик",
		Initiated: "На исполнении"
	},
	aliases: {
		legalBasisKind: {
			"PublicOffer": "Публичная оферта",
			"GuaranteeLetter": "Гарантийное письмо",
			"Agreement": "Договор"
		},
		permissions: {
			"counterparty": "Контрагенты",
			"counterparty-head": "Руководители контрагента",
			"counterparty-employee": "Сотрудники контрагента",
			"counterparty-employee-trust": "Доверенности сотрудников контрагента",
			"counterparty-employee-profile": "Профили сотрудников контрагента",
			"counterparty-document": "Документы контрагента",
			"counterparty-fns": "ФНС",
			"counterparty-master-account": "Мастер-аккаунт контрагента",
			"counterparty-property": "Объекты имущества контрагента",
			"counterparty-boat": "Суда контрагента",
			"raw-counterparty-boat": "Черновики судов контрагента",
			"counterparty-boat-type": "Типы судов контрагента",
			"boat-flag": "Флаги",
			"ship-owner": "Судовладельцы",
			"office-employee": "Сотрудники офиса",
			"office-employee-trust": "Доверенности сотрудника офиса",
			"office-employee-profile": "Профили сотрудника офиса",
			"account": "Аккаунты",
			"account-profile": "Профили аккаунтов",
			"master-account-application": "Заявки на мастер-аккаунт",
			"employee-join-application": "Заявки на вступление в организацию",
			"employee-join-application-status": "Заявки на вступление в организацию в системе",
			"service": "Услуги",
			"tariff": "Тарифы",
			"tariff-rate": "Тарифные ставки",
			"service-tariff-approval-order": "Приказы",
			"agreement": "Договоры",
			"division": "Подразделения",
			"destination": "Место назначения",
			"destinations": "Места назначения",
			"division-contact": "Контакты подразделения",
			"division-contact-hours": "Часы работы контактов",
			"enterprise-role": "Роли предприятия",
			"permission": "Права доступа",
			"agreement-definition": "Шаблоны договоров",
			"outside-portal-service-application": "Услуги обработанные вне портала",
			"enterprise-property": "Объекты имущества предприятия",
			"enterprise-employee": "Сотрудники предприятия",
			"enterprise-employee-profile": "Профили сотрудников предприятия",
			description: {
				"read": "Право на чтение",
				"create": "Право на создание",
				"update": "Право на обновление",
				"accept": "Право на одобрение",
				"decline": "Право на отклонение",
				"cancel": "Право на отмену",
				"delete": "Право на удаление"
			},
			actions: {
				"all": "Все",
				"read": "Права на чтение",
				"create": "Права на создание",
				"update": "Права на обновление",
				"accept": "Права на одобрение",
				"decline": "Права на отклонение",
				"cancel": "Права на отмену",
				"delete": "Права на удаление"
			}
		},
		statusBoat: {
			free: "Свободен",
			busy: "Занят",
			repair: "В ремонте"
		},
		contactType: {
			[ApiDivisionsContactType.Vhf]: "УКВ",
			[ApiDivisionsContactType.Fax]: "Факс",
			[ApiDivisionsContactType.Other]: "Другое",
			[ApiDivisionsContactType.Phone]: "Номер телефона",
			[ApiDivisionsContactType.Email]: "Электронная почта"
		},
		paymentMethod: {
			[ApiServicesPaymentMethod.PrePayment]: "Предоплата",
			[ApiServicesPaymentMethod.PostPayment]: "Постоплата"
		},
		approveStatus: {
			Created: "Открыт",
			Approved: "Одобрен",
			Rejected: "Отклонен",
			Undefined: "Неизвестно"
		},
		applicationStatus: {
			[ApiCounterpartyBoatApplicationStatus.Created]: "На рассмотрении",
			[ApiCounterpartyBoatApplicationStatus.Approved]: "Одобрено",
			[ApiCounterpartyBoatApplicationStatus.Declined]: "Отклонено"
		},
		boatsFilterStatus: {
			"All": "Все",
			"Created": "На рассмотрении",
			"Accepted": "Утвержден"
		},
		trustStatus: {
			Undefined: "Неизвестно",
			Created: "На рассмотрении",
			Accepted: "Одобрена",
			Declined: "Отклонена"
		},
		tariffRateStatus: {
			[TariffRateStatusTypeEnum.ACTIVE]: "Активна",
			[TariffRateStatusTypeEnum.UPCOMING]: "Дата начала ещё не наступила",
			[TariffRateStatusTypeEnum.EXPIRED]: "Срок действия истёк"
		},
		documentTypes: {
			[DocumentType.inn]: "Свидетельство ИНН руководителя",
			[DocumentType.appointmentHeadOrder]: "Приказ о назначении руководителем"
		},
		documents: {
			[STORAGE_INN_NAMESPACE]: "ИНН",
			"trust/files": "Файл доверенности",
			signatureGeneral: "Сведения об электронной подписи",
			trustTemplate: "Шаблон доверенности",
			[STORAGE_APPOINTMENT_HEAD_ORDER]: "Приказ о назначении руководителем",
			[STORAGE_SIGNED_REQUEST]: "Запрос, подписанный электронной подписью руководителя",
			treasuryStatement: "Файл выписки",
			[DocumentType.ownershipCertificate]: "Свидетельство о праве плавания под флагом",
			[DocumentType.internationalMeasuringCertificate]: "Международное мерительное свидетельство",
			[DocumentType.classificationCertificate]: "Классификационное свидетельство",
			[DocumentType.internationalOilPollutionPreventionCertificate]: "Международное свидетельство о предотвращении загрязнения нефтью",
			[DocumentType.customDocuments]: "Иной документ",
			[DocumentType.agreement]: "Договор",
			[DocumentType.account]: "Счет",
			[DocumentType.outfitTasks]: "Наряд-задание",
			[DocumentType.servicesActs]: "Акт об оказании услуг",
			[DocumentType.invoices]: "Счет-фактура",
			[DocumentType.associationArticle]: "Устав организации",
			[DocumentType.associationMemorandum]: "Учредительный договор",
			agreementDefinitionDocumentTemplate: "Шаблон документа договора"
		},
		documentTemplateName: {
			agreementDefinition: "Шаблон договора",
			guaranteeLetterDefinition: "Шаблон гарантийного письма",
			publicOfferDefinition: "Шаблон публичной оферты",
			invoice: "Шаблон счета"
		},
		counterpartyType: {
			[CounterpartyTypeEnum.LEGAL_ENTITY]: "Юридическое лицо",
			[CounterpartyTypeEnum.LEGAL_PERSON]: "Индивидуальный предприниматель",
			[CounterpartyTypeEnum.PHYSICAL_PERSON]: "Физическое лицо",
			[CounterpartyTypeEnum.FOREIGN_ORGANIZATION]: "Иностранная организация"
		},
		counterpartyTypeAbbreviation: {
			[CounterpartyTypeEnum.LEGAL_ENTITY]: "ЮЛ",
			[CounterpartyTypeEnum.LEGAL_PERSON]: "ИП"
		},
		counterpartyEmployeeTrustStatus: {
			[ApiDtoTrustUiStatus.Absent]: "Отсутствует",
			[ApiDtoTrustUiStatus.Review]: "На рассмотрении",
			[ApiDtoTrustUiStatus.Active]: "Действующая",
			[ApiDtoTrustUiStatus.Rejected]: "Отклонена",
			[ApiDtoTrustUiStatus.Outdated]: "Срок действия истек"
		},
		contactScope: {
			"Public": "Публичный",
			"Private": "Внутренний",
			"All": "Все"
		},
		activeStatus: {
			active: "Активен",
			inactive: "Неактивен"
		},
		publishedStatus: {
			published: "Опубликована",
			notPublished: "Не опубликована"
		},
		documentStatus: {
			active: "Активный",
			archived: "Архивный"
		},
		enterprisePropertyStatus: {
			[ArchiveStatusType.ACTIVE]: "Активный",
			[ArchiveStatusType.ARCHIVED]: "В архиве"
		},
		registerClass: {
			"River": "Речной",
			"Sea": "Морской",
			"RiverSea": "Смешанный"
		},
		affirmation: {
			yes: "Да",
			no: "Нет"
		},
		confirmation: {
			confirmed: "Подтверджен",
			notConfirmed: "Не подтвержден"
		},
		itemAvailable: {
			available: "Есть",
			notAvailable: "Нет"
		},
		userAgreement: {
			pushingButton: "Нажимая кнопку",
			send: "“Отправить”",
			iGiveMyConsentToProcessingMyPersonalData: "Вы подтверждаете согласие лица, сведения о котором указаны в форме, на обработку персональных данных, в соответствии с Федеральным законом от 27.07.2006 года № 152-ФЗ",
			onPersonalData: "“О персональных данных”, на условиях и для целей, определенных в",
			consentToProcessingMyPersonalData: "Согласии на обработку персональных данных."
		},
		filterArchiveStatus: {
			[ArchiveStatusType.ALL]: "Все",
			[ArchiveStatusType.ACTIVE]: "Активные",
			[ArchiveStatusType.ARCHIVED]: "В архиве"
		},
		filterApplicationStatus: {
			undefined: "Все",
			[ApplicationFilterStatusType.ALL]: "Все",
			[ApplicationFilterStatusType.APPROVED]: "Одобрено",
			[ApplicationFilterStatusType.DECLINED]: "Отклонено",
			[ApplicationFilterStatusType.CREATED]: "На рассмотрении"
		},
		counterpartyDocumentType: {
			[ApiCounterpartyDocumentsDocumentType.MemorandumOfAssociation]: "Учредительный договор",
			[ApiCounterpartyDocumentsDocumentType.OrderAppointingTheHead]: "Приказ о назначении руководителя",
			[ApiCounterpartyDocumentsDocumentType.StatuteOfTheOrganization]: "Устав организации"
		},
		propertyType: {
			[ApiPropertiesBoatType.Tugboat]: "Буксир",
			[ApiPropertiesBoatType.Crewboat]: "Разъездное судно",
			[ApiPropertiesBoatType.FloatingCrane]: "Плавкран",
			[ApiPropertiesBoatType.Icebreaker]: "Ледокол",
			[ApiPropertiesBoatType.EnvironmentalVessel]: "Судно экологического назначения",
			[ApiPropertiesBoatType.HydrographicBoat]: "Гидрографический катер",
			Pier: "Причал"
		},
		boatApplicationDocumentType: {
			[BoatApplicationDocumentType.ownershipCertificate]: "Свидетельство о праве плавания под флагом",
			[BoatApplicationDocumentType.classificationCertificate]: "Классификационное свидетельство",
			[BoatApplicationDocumentType.customDocuments]: "Иной документ",
			[BoatApplicationDocumentType.internationalMeasuringCertificate]: "Международное мерительное свидетельство",
			[BoatApplicationDocumentType.internationalOilPollutionPreventionCertificate]: "Международное свидетельство о предотвращении загрязнения нефтью"
		},
		archiveStatus: {
			default: {
				[ArchiveStatusType.ACTIVE]: "Активен",
				[ArchiveStatusType.ARCHIVED]: "В архиве"
			},
			service: {
				[ArchiveStatusType.ACTIVE]: "Активен",
				[ArchiveStatusType.ARCHIVED]: "В архиве"
			},
			branch: {
				[ArchiveStatusType.ACTIVE]: "Активен",
				[ArchiveStatusType.ARCHIVED]: "В архиве"
			},
			department: {
				[ArchiveStatusType.ACTIVE]: "Активно",
				[ArchiveStatusType.ARCHIVED]: "В архиве"
			},
			port: {
				[ArchiveStatusType.ACTIVE]: "Активен",
				[ArchiveStatusType.ARCHIVED]: "В архиве"
			},
			pier: {
				[ArchiveStatusType.ACTIVE]: "Активен",
				[ArchiveStatusType.ARCHIVED]: "В архиве"
			},
			tugboat: {
				[ArchiveStatusType.ACTIVE]: "Активен",
				[ArchiveStatusType.ARCHIVED]: "В архиве"
			},
			icebreaker: {
				[ArchiveStatusType.ACTIVE]: "Активен",
				[ArchiveStatusType.ARCHIVED]: "В архиве"
			},
			environmentalVessel: {
				[ArchiveStatusType.ACTIVE]: "Активно",
				[ArchiveStatusType.ARCHIVED]: "В архиве"
			},
			hydrographicBoat: {
				[ArchiveStatusType.ACTIVE]: "Активен",
				[ArchiveStatusType.ARCHIVED]: "В архиве"
			},
			floatingCrane: {
				[ArchiveStatusType.ACTIVE]: "Активен",
				[ArchiveStatusType.ARCHIVED]: "В архиве"
			},
			crewboat: {
				[ArchiveStatusType.ACTIVE]: "Активно",
				[ArchiveStatusType.ARCHIVED]: "В архиве"
			},
			tariffs: {
				[ArchiveStatusType.ACTIVE]: "Активно",
				[ArchiveStatusType.ARCHIVED]: "В архиве"
			},
			boat: {
				[ArchiveStatusType.ACTIVE]: "Активен",
				[ArchiveStatusType.ARCHIVED]: "В архиве"
			}
		},
		serviceFilter: {
			[ApiServiceType.CrewBoatService]: "Разъездные суда",
			[ApiServiceType.PilotTransfer]: "Доставка лоцманов",
			[ApiServiceType.TugService]: "Буксирные услуги",
			[ApiServiceType.DrinkingWater]: "Бункеровка питьевой водой",
			[ApiServiceType.DeviationRemoval]: "Устранение девиации",
			[ApiServiceType.IndividualIcebreakerAssistance]: "Индивидуальная ледокольная проводка",
			[ApiServiceType.InformationService]: "Информационные услуги",
			[ApiServiceType.Ecological]: "Экологические услуги",
			[ApiServiceType.PierService]: "Стоянка у причалов",
			[ApiServiceType.IcePilotService]: "Ледовые лоцманы",
			[ApiServiceType.LinkspanBridge]: "Стыковка с подъёмно-переходным мостом",
			[ApiServiceType.GeodeticHydrographicService]: "Геодезия и гидрография",
			[ApiServiceType.DredgingService]: "Дноуглубительные услуги",
			[ApiServiceType.SnoInstallationService]: "Установка и обслуживание СНО",
			[ApiServiceType.FloatingCraneService]: "Услуги плавкрана",
			[ApiServiceType.Icebreaking]: "Ледокольные услуги",
			[ApiServiceType.Consulting]: "Консультационные услуги"
		},
		serviceAbbreviation: {
			[ApiServiceType.Undefined]: "Не определено",
			[ApiServiceType.TugService]: "БКУ",
			[ApiServiceType.CrewBoatService]: "УРС",
			[ApiServiceType.InformationService]: "ИТУ",
			[ApiServiceType.FloatingCraneService]: "УПК",
			[ApiServiceType.PierService]: "УПП",
			[ApiServiceType.GeodeticHydrographicService]: "ГГУ",
			[ApiServiceType.SnoInstallationService]: "СНО",
			[ApiServiceType.DredgingService]: "ДГУ",
			
			[ApiServiceType.IcePilotService]: "УЛЛ",
			[ApiServiceType.Consulting]: "КСУ",
			[ApiServiceType.Icebreaking]: "ЛДУ",
			[ApiServiceType.DeviationRemoval]: "УУД",
			[ApiServiceType.IndividualIcebreakerAssistance]: "ИЛП",
			[ApiServiceType.DrinkingWater]: "БСВ",
			[ApiServiceType.PilotTransfer]: "УДЛ",
			[ApiServiceType.Ecological]: "ЭКУ",
			[ApiServiceType.LinkspanBridge]: "ППМ"
		},
		service: {
			[ApiServiceType.Undefined]: "Не определено",
			[ApiServiceType.TugService]: "Буксирные услуги",
			[ApiServiceType.CrewBoatService]: "Услуги по предоставлению разъездных судов",
			[ApiServiceType.InformationService]: "Информационные услуги",
			[ApiServiceType.FloatingCraneService]: "Услуги плавкрана",
			[ApiServiceType.PierService]: "Услуги по предоставлению причалов для стоянки судов",
			[ApiServiceType.GeodeticHydrographicService]: "Геодезические и гидрографические услуги",
			[ApiServiceType.SnoInstallationService]: "Услуги по установке и обслуживанию СНО",
			[ApiServiceType.DredgingService]: "Дноуглубительные услуги",
			[ApiServiceType.IcePilotService]: "Услуги ледовых лоцманов",
			[ApiServiceType.Consulting]: "Консультационные услуги",
			[ApiServiceType.Icebreaking]: "Ледокольные услуги",
			[ApiServiceType.DeviationRemoval]: "Услуги по устранению/уничтожению девиации",
			[ApiServiceType.IndividualIcebreakerAssistance]: "Услуги по индивидуальной ледокольной проводке",
			[ApiServiceType.DrinkingWater]: "Услуги по бункеровке судов питьевой водой",
			[ApiServiceType.PilotTransfer]: "Услуги по доставке лоцманов",
			[ApiServiceType.Ecological]: "Экологические услуги",
			[ApiServiceType.LinkspanBridge]: "Услуги по стыковке-расстыковке морских судов с подъемно-переходным мостом"
		},
		servicesFilter: {
			myServices: "Мои услуги",
			allDepartmentServices: "Все услуги управления",
			allBranchServices: "Все услуги филиала",
			allBranchesServices: "Все услуги филиалов"
		},
		serviceStatusFilter: {
			ALL: "Все"
		},
		propertyName: {
			[ApiEnterprisePropertyType.Tugboat]: "Буксир",
			[ApiEnterprisePropertyType.Crewboat]: "Разъездное судно",
			[ApiEnterprisePropertyType.FloatingCrane]: "Плавкран",
			[ApiEnterprisePropertyType.Pier]: "Причал",
			[ApiEnterprisePropertyType.EnvironmentalVessel]: "Судно экологического назначения",
			[ApiEnterprisePropertyType.HydrographicBoat]: "Гидрографический катер"
		},
		masterAccountAccessStatusFilter: {
			[ApiServiceRequestsMasterApplicationStatus.Created]: "Открыт",
			[ApiServiceRequestsMasterApplicationStatus.Approved]: "Одобрен",
			[ApiServiceRequestsMasterApplicationStatus.Rejected]: "Отклонен"
		},
		trustActionerKind: {
			[ApiGetTrustActioner_ActionerKind.Acceptor]: "Одобрил",
			[ApiGetTrustActioner_ActionerKind.Decliner]: "Отклонил",
			[ApiGetTrustActioner_ActionerKind.Canceller]: "Отменил изменения"
		},
		units: {
			[ApiTariffsUnit.MeterPerHour]: "м/час",
			[ApiTariffsUnit.MeterPerDay]: "м/сутки",
			[ApiTariffsUnit.CubicMeter]: "куб.м.",
			[ApiTariffsUnit.Hour]: "час",
			[ApiTariffsUnit.Month]: "мес.",
			[ApiTariffsUnit.Day]: "сутки",
			[ApiTariffsUnit.Item]: "ед."
		},
		roles: {
			admin: "Администратор",
			canSign: "Может осуществлять подписание документов от имени предприятия"
		},
		transitions: {
			services: {
				[ApiServiceApplicationWorkflowTransitionKind.Complete]: "Завершить заявку",
				[ApiServiceApplicationWorkflowTransitionKind.Cancel]: "Отменить заявку",
				[ApiServiceApplicationWorkflowTransitionKind.RequestCancellation]: "Запросить отмену заявки",
				[ApiServiceApplicationWorkflowTransitionKind.Reject]: "Отклонить заявку",
				[ApiServiceApplicationWorkflowTransitionKind.SubmitForPossibilityConfirmation]: "Направить на подтверждение возможности оказания",
				[ApiServiceApplicationWorkflowTransitionKind.ConfirmPossibility]: "Подтвердить возможность оказания",
				[ApiServiceApplicationWorkflowTransitionKind.AssignResource]: "Назначить объект имущества",
				[ApiServiceApplicationWorkflowTransitionKind.ScheduleService]: "Запланировать оказание услуг",
				[ApiServiceApplicationWorkflowTransitionKind.StartProviding]: "Начать оказание услуг",
				[ApiServiceApplicationWorkflowTransitionKind.FinishProviding]: "Завершить оказание услуг",
				[ApiServiceApplicationWorkflowTransitionKind.StartClosingDocumentsPreparation]: "Начать подготовку закрывающих документов",
				[ApiServiceApplicationWorkflowTransitionKind.AttachAct]: "Подготовить акт",
				[ApiServiceApplicationWorkflowTransitionKind.SignActByEnterprise]: "Подписать акт",
				[ApiServiceApplicationWorkflowTransitionKind.AttachAccountingDocuments]: "Подготовить расчетные документы",
				[ApiServiceApplicationWorkflowTransitionKind.SignAccountingDocumentsByEnterprise]: "Подписать расчетные документы",
				[ApiServiceApplicationWorkflowTransitionKind.SignActByCounterparty]: "Подписать акт",
				[ApiServiceApplicationWorkflowTransitionKind.ApproveCancellation]: "Подтвердить отмену",
				[ApiServiceApplicationWorkflowTransitionKind.RejectCancellation]: "Отклонить запрос на отмену"
			},
			agreements: {
				[ApiServicesAgreementWorkflowTransitionKind.Create]: "Создание",
				[ApiServicesAgreementWorkflowTransitionKind.Update]: "Обновление",
				[ApiServicesAgreementWorkflowTransitionKind.Send]: "Отправка",
				[ApiServicesAgreementWorkflowTransitionKind.Start]: "Начало исполнения",
				[ApiServicesAgreementWorkflowTransitionKind.Finish]: "Завершение исполнения",
				[ApiServicesAgreementWorkflowTransitionKind.FinallySign]: "Окончательное подписание",
				[ApiServicesAgreementWorkflowTransitionKind.Cancel]: "Отмена",
				[ApiServicesAgreementWorkflowTransitionKind.Reject]: "Отклонение",
				[ApiServicesAgreementWorkflowTransitionKind.Expired]: "Истечение срока действия",
				[ApiServicesAgreementWorkflowTransitionKind.Negotiate]: "Инициация согласования"
			}
		},
		serviceWorkflowTransition: {
			[ApiServiceApplicationWorkflowTransitionKind.SubmitForPossibilityConfirmation]: "Направить на подтверждение возможности оказания",
			[ApiServiceApplicationWorkflowTransitionKind.ConfirmPossibility]: "Подтвердить возможность оказания",
			[ApiServiceApplicationWorkflowTransitionKind.AssignResource]: "Назначить ресурс",
			[ApiServiceApplicationWorkflowTransitionKind.ScheduleService]: "Запланировать оказание услуг",
			[ApiServiceApplicationWorkflowTransitionKind.StartClosingDocumentsPreparation]: "Начать подготовку закрывающих документов",
			[ApiServiceApplicationWorkflowTransitionKind.AttachAct]: "Прикрепить акт",
			[ApiServiceApplicationWorkflowTransitionKind.SignActByEnterprise]: "Подписать акт со стороны предприятия",
			[ApiServiceApplicationWorkflowTransitionKind.AttachAccountingDocuments]: "Прикрепить расчётные документы",
			[ApiServiceApplicationWorkflowTransitionKind.SignActByCounterparty]: "Подписать акт со стороны контрагента",
			[ApiServiceApplicationWorkflowTransitionKind.SignAccountingDocumentsByEnterprise]: "Подписать расчётные документы со стороны предприятия",
			[ApiServiceApplicationWorkflowTransitionKind.Complete]: "Завершить заявку",
			[ApiServiceApplicationWorkflowTransitionKind.StartProviding]: "Начать оказание услуг",
			[ApiServiceApplicationWorkflowTransitionKind.FinishProviding]: "Завершить оказание услуг",
			[ApiServiceApplicationWorkflowTransitionKind.Cancel]: "Отменить заявку",
			[ApiServiceApplicationWorkflowTransitionKind.RequestCancellation]: "Запросить отмену заявки",
			[ApiServiceApplicationWorkflowTransitionKind.RejectCancellation]: "Отклонить запрос на отмену",
			[ApiServiceApplicationWorkflowTransitionKind.ApproveCancellation]: "Подтвердить запрос на отмену",
			[ApiServiceApplicationWorkflowTransitionKind.Reject]: "Отклонить заявку",
			[ApiServiceApplicationWorkflowTransitionKind.ReturnToProviding]: "Вернуть к оказанию услуг",
			[ApiServiceApplicationWorkflowTransitionKind.ReturnToProvided]: "Вернуть к завершённому оказанию услуг",
			[ApiServiceApplicationWorkflowTransitionKind.ReturnToClosingDocumentsPreparation]: "Вернуть к подготовке закрывающих документов",
			[ApiServiceApplicationWorkflowTransitionKind.ReturnToActAttached]: "Вернуть к прикреплённому акту",
			[ApiServiceApplicationWorkflowTransitionKind.ReturnToActSignedByEnterprise]: "Вернуть к акту, подписанному предприятием",
			[ApiServiceApplicationWorkflowTransitionKind.ReturnToAccountingDocumentsAttached]: "Вернуть к прикреплённым расчётным документам"
		},
		recipientType: {
			[ApiNotificationsRecipientType.TargetUser]: "Целевой пользователь",
			[ApiNotificationsRecipientType.CounterpartyEmployees]: "Сотрудники контрагента",
			[ApiNotificationsRecipientType.EnterpriseEmployees]: "Сотрудники предприятия"
		}
	},
	links: {
		agreementServices: "Список услуг по договору"
	},
	boat: {
		imo: "Номер IMO",
		mmsi: "Номер MMSI",
		flag: "Флаг",
		volume: "Объем судна, м3",
		numberOfRegistry: "Регистровый номер",
		callSign: "Позывной"
	},
	servicesItem: {
		number: "№",
		type: "Тип",
		counterparty: "Контрагент",
		agreement: "Договор",
		department: "Управление",
		port: "Порт",
		createdAt: "Создана",
		status: "Статус",
		totalAmount: "Стоимость",
		start: "Начало",
		end: "Окончание",
		enterpriseProperty: "Объект имущества",
		counterpartyBoat: "Судно"
	},
	tariffRatesItem: {
		unitPrice: "Цена за единицу измерения",
		number: "Номер",
		startDate: "Дата начала действия",
		createdAt: "Создана",
		status: "Статус"
	},
	service: {
		tariff: {
			approximateCost: "Предварительная стоимость",
			approximateCostWithVat: "Предварительная стоимость (в том числе НДС)",
			actualCost: "Фактическая стоимость",
			actualCostWithVat: "Фактическая стоимость (в том числе НДС)",
			costWithVat: "Стоимость (в том числе НДС)",
			price: "Стоимость",
			timeSpent: "Затрачено времени",
			expectedSpent: "Ожидаемые затраты времени",
			expectedVolume: "Ожидаемый объём",
			expectedVolumePlaceholder: "Введите количество",
			startDateRequiredHint: "Для ввода значения укажите дату начала",
			startDateTimeRequiredHint: "Для ввода значения укажите дату и время начала",
			costCalculationStartDateRequiredHint: "Для расчёта стоимости укажите дату начала",
			drinkingWaterAutoCalculationHint: "Для автоматического расчёта фактического объёма укажите начальные и конечные показания счётчика.",
			timeSpentPlaceholder: "ЧЧ:ММ",
			monthsNumber: "Количество месяцев",
			monthsNumberPlaceholder: "Введите количество",
			daysNumber: "Количество дней",
			itemsNumber: "Количество единиц",
			daysNumberPlaceholder: "Введите количество",
			itemsNumberPlaceholder: "Введите количество",
			vat: "НДС",
			withoutVat: "Без НДС",
			unitPrice: "Цена за единицу измерения",
			valueTitle: {
				[ApiTariffsUnit.CubicMeter]: "Объем, м3",
				[ApiTariffsUnit.Hour]: "Затрачено времени",
				[ApiTariffsUnit.MeterPerDay]: "Количество часов",
				[ApiTariffsUnit.Month]: "Количество месяцев",
				[ApiTariffsUnit.Day]: "Количество суток",
				[ApiTariffsUnit.Item]: "Количество единиц",
				[ApiTariffsUnit.MeterPerHour]: "Количество часов"
			},
			requestedValue: {
				[ApiTariffsUnit.CubicMeter]: "Объем, м3",
				[ApiTariffsUnit.Hour]: "Ожидаемые затраты времени",
				[ApiTariffsUnit.MeterPerDay]: "Ожидаемое количество часов",
				[ApiTariffsUnit.Month]: "Ожидаемое количество месяцев",
				[ApiTariffsUnit.Day]: "Ожидаемое количество суток",
				[ApiTariffsUnit.Item]: "Ожидаемое количество единиц",
				[ApiTariffsUnit.MeterPerHour]: "Ожидаемое количество часов"
			},
			actualValue: {
				[ApiTariffsUnit.CubicMeter]: "Фактический объём",
				[ApiTariffsUnit.Hour]: "Фактические затраты времени",
				[ApiTariffsUnit.MeterPerDay]: "Фактическое количество часов",
				[ApiTariffsUnit.Month]: "Фактическое количество месяцев",
				[ApiTariffsUnit.Day]: "Фактическое количество суток",
				[ApiTariffsUnit.Item]: "Фактическое количество единиц",
				[ApiTariffsUnit.MeterPerHour]: "Фактическое количество часов"
			}
		},
		agreement: {
			multiServicesAgreement: "Рамочный договор",
			title: {
				[ApiServiceType.PierService]: "Договор на оказание услуг по предоставлению причала",
				[ApiServiceType.TugService]: "Договор на оказание буксирных услуг",
				[ApiServiceType.CrewBoatService]: "Договор на оказание услуг по предоставлению разъездных судов",
				[ApiServiceType.DredgingService]: "Договор на оказание дноуглубительных услуг",
				[ApiServiceType.SnoInstallationService]: "Договор на услуги по установке и обслуживанию СНО",
				[ApiServiceType.GeodeticHydrographicService]: "Договор на оказание геодезических и гидрографических услуг",
				[ApiServiceType.FloatingCraneService]: "Договор на оказание услуг плавкрана",
				[ApiServiceType.InformationService]: "Договор на оказание информационных услуг",
				[ApiServiceType.IcePilotService]: "Договор на оказание услуг ледовых лоцманов",
				[ApiServiceType.Consulting]: "Договор на оказание консультационных услуг",
				[ApiServiceType.Icebreaking]: "Договор на оказание ледокольных услуг",
				[ApiServiceType.DeviationRemoval]: "Договор на услуги по устранению/уничтожению девиации",
				[ApiServiceType.IndividualIcebreakerAssistance]: "Договор на оказание услуг по индивидуальной ледокольной проводке",
				[ApiServiceType.DrinkingWater]: "Договор на услуги по бункеровке судов питьевой водой",
				[ApiServiceType.PilotTransfer]: "Договор на оказание услуг по доставке лоцманов",
				[ApiServiceType.Ecological]: "Договор на оказание экологических услуг",
				[ApiServiceType.LinkspanBridge]: "Договор на услуги по стыковке/расстыковке с подъемно-переходным мостом"
			}
		},
		tugBoat: {
			title: "Наименование буксира"
		},
		dateLocation: {
			form: {
				title: "Время и место",
				date: "Дата начала",
				time: "Время начала",
				startLocation: "Место начала",
				endLocation: "Место окончания",
				startDate: "Дата начала работы",
				endDate: "Дата окончания работы",
				startTime: "Время начала работы",
				endTime: "Время окончания работы"
			},
			details: {
				title: "Время и место",
				startLocation: "Место начала",
				endLocation: "Место окончания",
				startDate: "Дата начала",
				startTime: "Время начала",
				endDate: "Дата окончания",
				endTime: "Время окончания"
			}
		},
		workflowState: {
			[ApiServiceWorkflowStateKind.Draft]: "Черновик",
			[ApiServiceWorkflowStateKind.PossibilityConfirmation]: "На подтверждении возможности оказания",
			[ApiServiceWorkflowStateKind.PossibilityConfirmed]: "Возможность оказания подтверждена",
			[ApiServiceWorkflowStateKind.ResourceAssigned]: "Объект имущества назначен",
			[ApiServiceWorkflowStateKind.Scheduled]: "Оказание услуг запланировано",
			[ApiServiceWorkflowStateKind.Providing]: "Услуги оказываются",
			[ApiServiceWorkflowStateKind.Provided]: "Услуги оказаны",
			[ApiServiceWorkflowStateKind.ClosingDocumentsPreparation]: "Подготовка закрывающих документов",
			[ApiServiceWorkflowStateKind.ActAttached]: "Акт подготовлен",
			[ApiServiceWorkflowStateKind.ActSignedByEnterprise]: "Акт подписан ФГУП «Росморпорт»",
			[ApiServiceWorkflowStateKind.AccountingDocumentsAttached]: "Расчетные документы подготовлены",
			[ApiServiceWorkflowStateKind.AccountingDocumentsSignedByEnterprise]: "Расчетные документы подписаны ФГУП «Росморпорт»",
			[ApiServiceWorkflowStateKind.ActSignedByCounterparty]: "Акт подписан контрагентом",
			[ApiServiceWorkflowStateKind.CancellationRequested]: "Запрошена отмена",
			[ApiServiceWorkflowStateKind.Rejected]: "Заявка отклонена",
			[ApiServiceWorkflowStateKind.Cancelled]: "Заявка отменена",
			[ApiServiceWorkflowStateKind.Completed]: "Заявка завершена"
		},
		signDocuments: "Подписать документы",
		documentsSigned: "Документы успешно подписаны.",
		diadocDocumentStatus: {
			Created: "Не отправлен в Диадок",
			SignedByEnterpriseSending: "Отправляется в Диадок",
			SignedByEnterpriseSent: "Отправлен в Диадок",
			SignedByCounterpartySending: "Отправляется в Диадок",
			SignedByCounterpartySent: "Отправлен в Диадок"
		},
		utd: {
			generated: "УПД успешно сформирован.",
			confirmSignature: "Подтвердить подпись и завершить заявку",
			completionPending: "УПД подписан. Ожидается автоматическое завершение заявки.",
			refreshStatus: "Обновить статус",
			transitions: {
				AttachAccountingDocuments: "Прикрепить УПД",
				SignAccountingDocumentsByEnterprise: "Подписать УПД"
			},
			workflowState: {
				AccountingDocumentsAttached: "УПД подготовлен",
				AccountingDocumentsSignedByEnterprise: "УПД подписан ФГУП «Росморпорт»"
			}
		},
		propertyTariff: {
			multipleSelectionAlert: "Вы можете выбрать несколько тарифов",
			title: {
				preferred: {
					[ApiServiceType.TugService]: "Запрошенные буксиры",
					[ApiServiceType.FloatingCraneService]: "Запрошенный плавкран",
					[ApiServiceType.CrewBoatService]: "Запрошенные разъездные суда",
					[ApiServiceType.IndividualIcebreakerAssistance]: "Запрошенные ледоколы",
					[ApiServiceType.Icebreaking]: "Запрошенные ледоколы",
					[ApiServiceType.PilotTransfer]: "Запрошенные разъездные суда",
					[ApiServiceType.PierService]: "Запрошенные причалы",
					[ApiServiceType.LinkspanBridge]: "Запрошенные операции",
					[ApiServiceType.InformationService]: "Запрошенные операции",
					[ApiServiceType.DeviationRemoval]: "Запрошенные операции",
					[ApiServiceType.DrinkingWater]: "Запрошенные операции",
					[ApiServiceType.IcePilotService]: "Запрошенные операции",
					[ApiServiceType.Ecological]: "Запрошенные суда экологического назначения",
					[ApiServiceType.GeodeticHydrographicService]: "Запрошенные гидрографические катера",
					byResourceKind: {
						default: "Запрошенные объекты имущества",
						tugboat: "Запрошенные буксиры",
						crewboat: "Запрошенные разъездные суда",
						floatingCrane: "Запрошенный плавкран",
						pier: "Запрошенные причалы",
						icebreaker: "Запрошенные ледоколы",
						environmentalVessel: "Запрошенные суда экологического назначения",
						hydrographicBoat: "Запрошенные гидрографические катера"
					}
				},
				[ApiServiceType.TugService]: "Назначенные буксиры",
				[ApiServiceType.CrewBoatService]: "Назначенные разъездные суда",
				[ApiServiceType.IndividualIcebreakerAssistance]: "Назначенные ледоколы",
				[ApiServiceType.Icebreaking]: "Назначенные ледоколы",
				[ApiServiceType.PilotTransfer]: "Назначенные разъездные суда",
				[ApiServiceType.PierService]: "Назначенные причалы",
				[ApiServiceType.LinkspanBridge]: "Операции",
				[ApiServiceType.FloatingCraneService]: "Назначенный плавкран",
				[ApiServiceType.InformationService]: "Операции",
				[ApiServiceType.DeviationRemoval]: "Операции",
				[ApiServiceType.DrinkingWater]: "Операции",
				[ApiServiceType.IcePilotService]: "Операции",
				[ApiServiceType.Ecological]: "Назначенные суда экологического назначения",
				[ApiServiceType.GeodeticHydrographicService]: "Назначенные гидрографические катера",
				byResourceKind: {
					default: "Назначенные объекты имущества",
					tugboat: "Назначенные буксиры",
					crewboat: "Назначенные разъездные суда",
					floatingCrane: "Назначенный плавкран",
					pier: "Назначенные причалы",
					icebreaker: "Назначенные ледоколы",
					environmentalVessel: "Назначенные суда экологического назначения",
					hydrographicBoat: "Назначенные гидрографические катера"
				}
			},
			propertyName: "Наименование",
			property: {
				[ApiServiceType.TugService]: "Буксир",
				[ApiServiceType.CrewBoatService]: "Разъездное судно",
				[ApiServiceType.IndividualIcebreakerAssistance]: "Ледокол",
				[ApiServiceType.Icebreaking]: "Ледокол",
				[ApiServiceType.PilotTransfer]: "Разъездное судно",
				[ApiServiceType.PierService]: "Причал",
				[ApiServiceType.LinkspanBridge]: "Операция",
				[ApiServiceType.FloatingCraneService]: "Плавкран",
				[ApiServiceType.InformationService]: "Операция",
				[ApiServiceType.DeviationRemoval]: "Операция",
				[ApiServiceType.DrinkingWater]: "Операция",
				[ApiServiceType.IcePilotService]: "Операция",
				[ApiServiceType.Ecological]: "Судно экологического назначения",
				[ApiServiceType.GeodeticHydrographicService]: "Гидрографический катер",
				byResourceKind: {
					default: "Объект имущества",
					tugboat: "Буксир",
					crewboat: "Разъездное судно",
					floatingCrane: "Плавкран",
					pier: "Причал",
					icebreaker: "Ледокол",
					environmentalVessel: "Судно экологического назначения",
					hydrographicBoat: "Гидрографический катер"
				}
			}
		},
		document: {
			[ApiServiceApplicationDocumentKind.GuaranteeLetter]: "Гарантийное письмо",
			[ApiServiceApplicationDocumentKind.ServiceAcceptanceCertificate]: "Акт об оказании услуг",
			[ApiServiceApplicationDocumentKind.FactureInvoice]: "Счёт-фактура",
			[ApiServiceApplicationDocumentKind.Utd]: "Универсальный передаточный документ (УПД)",
			[ApiServiceApplicationDocumentKind.Invoice]: "Счёт",
			[ApiServiceApplicationDocumentKind.GraphicAnnex]: "Графическое приложение",
			[ApiServiceApplicationDocumentKind.BuildingPermit]: "Разрешение на строительство",
			[ApiServiceApplicationDocumentKind.NatureInspectorateResolution]: "Разрешение Росприроднадзора на захоронение донного грунта, извлеченного при производстве работ по реализации указанного проекта",
			[ApiServiceApplicationDocumentKind.ChiefStateExpertise]: "Главгосэкспертиза о ГЭЭ",
			[ApiServiceApplicationDocumentKind.ProvidingWaterFacilityDecision]: "Решение о предоставлении водного объекта (свалка грунта) в пользование Заказчика",
			[ApiServiceApplicationDocumentKind.RosfishingConclusion]: "Заключение Росрыболовства о согласовании осуществления деятельности в рамках реализации указанного проекта",
			[ApiServiceApplicationDocumentKind.Agreement]: "Договор на оказание услуг",
			[ApiServiceApplicationDocumentKind.OrganizationCharter]: "Устав организации",
			[ApiServiceApplicationDocumentKind.FoundationAgreement]: "Учредительный договор",
			[ApiServiceApplicationDocumentKind.WorkOrder]: "Наряд-задание",
			[ApiServiceApplicationDocumentKind.OrderAssignment]: "Приказ-задание",
			[ApiServiceApplicationDocumentKind.ServiceConfirmationDocument]: "Подтверждающий документ",
			[ApiServiceApplicationDocumentKind.OtherDocument]: "Иной документ"
		}
	},
	agreement: {
		status: {
			[ApiServicesAgreementWorkflowStateKind.New]: "Создан",
			[ApiServicesAgreementWorkflowStateKind.Canceled]: "Отменен",
			[ApiServicesAgreementWorkflowStateKind.Rejected]: "Отклонен",
			[ApiServicesAgreementWorkflowStateKind.Draft]: "Черновик",
			[ApiServicesAgreementWorkflowStateKind.Sent]: "На рассмотрении у сотрудника ФГУП «Росморпорт»",
			[ApiServicesAgreementWorkflowStateKind.Negotiated]: "Ожидает подпись ФГУП «Росморпорт»",
			[ApiServicesAgreementWorkflowStateKind.FinallySignedByEnterprise]: "Ожидает подпись сотрудника контрагента",
			[ApiServicesAgreementWorkflowStateKind.FinallySignedByCounterparty]: "Подписан сотрудником контрагента",
			[ApiServicesAgreementWorkflowStateKind.Active]: "Активен",
			[ApiServicesAgreementWorkflowStateKind.NotActive]: "Исполнен",
			[ApiServicesAgreementWorkflowStateKind.Expired]: "Истек срок действия",
			[ApiServiceType.TugService]: {
				[ApiServicesAgreementWorkflowStateKind.Sent]: "На рассмотрении у сотрудника службы эксплуатации флота"
			},
			[ApiServiceType.PierService]: {
				[ApiServicesAgreementWorkflowStateKind.Sent]: "На рассмотрении у диспетчера"
			},
			[ApiServiceType.CrewBoatService]: {
				[ApiServicesAgreementWorkflowStateKind.Sent]: "На рассмотрении у сотрудника службы эксплуатации флота"
			},
			[ApiServiceType.InformationService]: {
				[ApiServicesAgreementWorkflowStateKind.Sent]: "На рассмотрении у сотрудника финансового отдела"
			},
			[ApiServiceType.FloatingCraneService]: {
				[ApiServicesAgreementWorkflowStateKind.Sent]: "На рассмотрении у сотрудника службы эксплуатации флота"
			},
			[ApiServiceType.GeodeticHydrographicService]: {
				[ApiServicesAgreementWorkflowStateKind.Sent]: "На рассмотрении у сотрудника службы НГО"
			},
			[ApiServiceType.SnoInstallationService]: {
				[ApiServicesAgreementWorkflowStateKind.Sent]: "На рассмотрении у сотрудника службы НГО"
			},
			[ApiServiceType.DredgingService]: {
				[ApiServicesAgreementWorkflowStateKind.Sent]: "На рассмотрении у сотрудника службы эксплуатации флота"
			}
		},
		document: {
			[AgreementDocumentKindEnum.HEAD_APPOINTMENTS_ORDER]: "Приказ о назначении руководителя",
			[AgreementDocumentKindEnum.ORGANIZATION_CHARTER]: "Устав организации",
			[AgreementDocumentKindEnum.FOUNDATION_AGREEMENT]: "Учредительный договор",
			[AgreementDocumentKindEnum.AGREEMENT_NEGOTIATION_LIST]: "Лист согласования договора",
			[AgreementDocumentKindEnum.AGREEMENT]: "Договор",
			[AgreementDocumentKindEnum.OTHER_DOCUMENT]: "Иной документ"
		},
		workflowTransition: {
			[ApiServicesAgreementWorkflowStateKind.Negotiated]: "Отправить на подписание",
			[ApiServicesAgreementWorkflowStateKind.FinallySignedByEnterprise]: "Отправить на подписание контрагенту",
			[ApiServicesAgreementWorkflowStateKind.FinallySignedByCounterparty]: "Отправить документы",
			[ApiServicesAgreementWorkflowStateKind.Active]: "Активировать договор",
			[ApiServicesAgreementWorkflowStateKind.NotActive]: "Завершить"
		},
		additionalService: {
			additionalServiceTemplateName: "Наименование",
			isRequired: "Обязательные услуги",
			comment: "Комментарий"
		}
	},
	agreementsItem: {
		division: "Подразделение",
		agreementNumber: "№",
		counterpartyShortName: "Контрагент",
		serviceType: "Тип",
		department: "Управление",
		agreementDate: "Дата договора",
		signingDate: "Дата подписания",
		port: "Порты",
		startDate: "Дата начала",
		endDate: "Дата окончания",
		amount: "Баланс",
		state: "Статус",
		totalInvoices: "Сумма счетов",
		totalLimitAmount: "Лимит",
		portalProvidedServicesAmount: "Стоимость оказанных услуг",
		remainingPortalLimitAmount: "Остаток лимита"
	},
	boatApplicationsItem: {
		counterparty: "Организация",
		name: "Наименование",
		createdAt: "Дата подачи заявки",
		status: "Статус"
	},
	metricsItem: {
		score: "Оценка",
		comment: "Отзыв",
		avgScore: "Средняя оценка",
		maxScore: "Максимальная оценка",
		minScore: "Минимальная оценка",
		totalCount: "Всего оценок",
		serviceType: "Тип услуг",
		averageProcessingTime: "Среднее время обработки, ч",
		averageDelayTime: "Среднее время задержки, ч",
		minCost: "Минимальная сумма, ₽",
		maxCost: "Максимальная сумма, ₽",
		averageCost: "Средняя сумма, ₽",
		totalCost: "Общая сумма, ₽",
		propertyName: "Наименование объекта",
		propertyType: "Тип объекта",
		activeServices: "Активные услуги",
		totalServices: "Всего заявок",
		providedServices: "Завершённых заявок",
		rejectedServices: "Отклонённых сотрудниками заявок",
		canceledServices: "Отменённых контрагентами заявок",
		newCounterpartyEmployeesCount: "Новых сотрудников контрагента",
		newCounterpartiesCount: "Новых контрагентов",
		activeCounterpartiesCount: "Количество активных контрагентов",
		services: "Услуги",
		providedDate: "Дата выполнения",
		port: "Порт",
		sum: "Сумма, ₽",
		status: "Статус",
		totalAcceptancesCount: "Всего акцептов",
		totalAgreements: "Всего создано за период",
		activeAgreements: "Активировано за период"
	},
	metrics: {
		subtitles: {
			byTime: "Время обработки услуг",
			byCost: "Статистика по стоимости"
		},
		periods: {
			[MetricsPeriodType.CURRENT_MONTH]: "Текущий месяц",
			[MetricsPeriodType.PAST_MONTH]: "Прошедший месяц",
			[MetricsPeriodType.CURRENT_QUARTER]: "Текущий квартал",
			[MetricsPeriodType.PAST_QUARTER]: "Прошедший квартал",
			[MetricsPeriodType.CURRENT_YEAR]: "Текущий год",
			[MetricsPeriodType.PAST_YEAR]: "Прошедший год",
			[MetricsPeriodType.ALL_TIME]: "За всё время",
			[MetricsPeriodType.PERIOD]: "За период"
		}
	},
	notifications: {
		new: "Новое",
		empty: "Нет уведомлений",
		loading: "Загрузка уведомлений..."
	},
	warnings: {
		documentsInfo: "Вы можете воспользоваться разделом {0}{1} для загрузки и хранения ваших документов. Это позволит вам использовать их в дальнейшем без необходимости повторной загрузки."
	},
	messages: {
		browserNotificationsNotSupported: "Ваш браузер не поддерживает уведомления",
		browserNotificationsBlocked: "Уведомления заблокированы в настройках браузера"
	},
	components: {
		propertySchedule: {
			propertyColumn: "Наименование",
			status: {
				available: "Доступен",
				booked: "Забронирован",
				pending: "Бронь не подтверждена",
				partial: "Частично забронирован",
				unavailable: "Недоступен"
			}
		}
	},
	labels: {
		services: "Услуги",
		limit: "Лимит",
		ports: "Порты"
	},
	settings: {
		notificationsEnabled: {
			label: "Получать уведомления об изменении статусов заявок"
		},
		notificationApplicationsScope: {
			title: "Уведомления по заявкам",
			label: "По каким заявкам уведомлять"
		},
		notificationChangesScope: {
			title: "Уведомления по изменениям"
		}
	}
};
